{
    "Api tokens": {
        "add token": "Añadir token",
        "description": "Genera un token API para la descarga de archivos OEM para TCT y Configurator o un token API para que la aplicación lo utilice al solicitar servicios FOTA WEB. La documentación de la API se puede encontrar <1>aquí</1>.",
        "example": "Por ejemplo: fota_token",
        "generate token": "Generar token",
        "generated token": "Token generado",
        "last used at": "Último uso en",
        "name": "Nombre del token",
        "never": "Nunca",
        "no tokens": "No hay tokens disponibles",
        "no tokens description": "Una vez añadidos los tokens, aparecerán en la siguiente lista",
        "show token list": "Mostrar lista de tokens",
        "titles": {
            "Integration": {
                "description": "Se utiliza para la integración FOTA WEB en su sistema",
                "name": "Token de integración API"
            },
            "Tct": {
                "description": "Se utiliza para la descarga de archivos OEM para TCT y Configurator",
                "name": "Token TCT"
            }
        },
        "tokens": "Tokens API",
        "token type": "Tipo de token",
        "token was created": "El token se ha creado correctamente"
    },
    "Attributes": {
        "Completed": "Completado",
        "Count": "Contar",
        "Current": "Actual",
        "Date": "Fecha",
        "Empty": "Vacío",
        "excluded files": "Archivos excluidos (samegrade)",
        "Failed": "Fallido",
        "false": "",
        "Feature": "Característica",
        "file size bytes": "Tamaño total del archivo",
        "File_type": "Tipo de archivo",
        "File_version": "Versión del archivo",
        "Fingerprint_id": "Identificación por huella dactilar.",
        "Firmware_date": "Fecha del firmware",
        "Firmware_version": "Revisión",
        "included files": "Archivos incluidos",
        "Include_j1939": "",
        "Message": "Mensaje",
        "Metadata": "",
        "newest": "Desde lo más reciente",
        "oldest": "Desde el más antiguo",
        "Order": "Pedido",
        "Password_source": "",
        "Pending": "Pendiente",
        "Period": "Periodo",
        "Process_id": "",
        "Protocol_id": "ID de protocolo",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Específico",
        "Start": "Inicio",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Firmware BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Firmware CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Firmware TAPP"
        },
        "UserEntered": "",
        "vehicle": "Vehículo",
        "Vehicle_id": "Identificación de vehículos",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Comprueba tu aplicación de autenticación",
            "check email": "Comprueba tu correo electrónico",
            "code required": "Se requiere código de verificación.",
            "code sent to email": "Código enviado a tu correo electrónico",
            "code valid": "El código es válido durante varios minutos.",
            "enter code below": "e introduzca el código siguiente para iniciar sesión.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Se requiere un código de verificación. Comprueba tu aplicación de autenticación e introduce el código a continuación para iniciar sesión.",
        "check email": "Comprueba tu bandeja de entrada y haz clic en el enlace recibido para restablecer la contraseña.",
        "community forum": "Foro de asistencia colectiva",
        "contact us": "Contáctenos",
        "create initial password": "Crear contraseña",
        "create password": "Cree una contraseña que",
        "did not receive": "¿No ha recibido el enlace?",
        "do not have account": "¿Aún no tienes una cuenta?",
        "email": "Correo electrónico",
        "enter email": "Introduzca su correo electrónico registrado a continuación para recibir las instrucciones para restablecer la contraseña.",
        "forgot password": "¿Ha olvidado su contraseña?",
        "forgot your password": "¿Ha olvidado su contraseña?",
        "for ms365": "Para usuarios de Teltonika MS365.",
        "invalid email format": "Formato de correo electrónico no válido",
        "invalid password format": "Formato de contraseña no válido",
        "link sent": "¡Se ha enviado el enlace!",
        "length": "Mínimo 8 caracteres",
        "lowercase": "Contiene al menos una letra minúscula",
        "new password": "Nueva contraseña",
        "password": "Contraseña",
        "passwords do not match": "Las contraseñas no coinciden",
        "privacy policy": "Al utilizar FOTA WEB, usted acepta nuestra <1>Política de privacidad</1>.",
        "remember password": "¿Recuerdas tu contraseña?",
        "repeat password": "Repita la contraseña",
        "required": "Requerido",
        "resend": "Reenviar",
        "reset password": "Restablecer contraseña",
        "send reset link": "Enviar enlace de restablecimiento",
        "sign in": "Iniciar sesión",
        "sign in to fota": "Inicie sesión en su cuenta FOTA WEB",
        "signup": "Registrarse",
        "sso": "Iniciar sesión con Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Letra mayúscula",
        "user consent text": "Entiendo y acepto los <1>Términos de servicio</1> y el <2>Acuerdo de procesamiento de datos</2> de Teltonika.",
        "welcome": "Bienvenido a",
        "wiki": "Base de conocimientos de Telematics Wiki"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Aceptar",
        "accept all": "Aceptar todo",
        "accept selected": "Aceptar seleccionados",
        "actions": "Acciones",
        "add": "Añadir",
        "add device": "Añadir dispositivo",
        "add more files": "Añadir más archivos",
        "add new": "Añadir nuevo",
        "agree": "Acepto",
        "all companies": "Todas las empresas",
        "all of company": "Todo {{companyName}}",
        "all rows selected": {
            "devices": "Se han seleccionado todos los {{count}} dispositivos",
            "tasks": "Se seleccionan todas las {{count}} tareas pendientes/en ejecución",
            "groups": "Se han seleccionado todos los {{count}} grupos",
            "files": "Se han seleccionado todos los {{count}} archivos",
            "companies": "Se han seleccionado todas las {{count}} empresas",
            "users": "Se seleccionan todos los {{count}} usuarios"
        },
        "approve": "Aprobar",
        "assign": "Asignar",
        "assigning": "Asignación",
        "auto sync": "",
        "back": "Atrás",
        "back to sign in": "Volver a iniciar sesión",
        "cancel": "Cancelar",
        "cancelling": "Cancelación",
        "cancel all tasks in group": "Cancelar todas las tareas del grupo",
        "cancel tasks": "Cancelar tareas",
        "cannot create desktop licenses": "No se pueden crear licencias para empresas internas.",
        "cannot create offline licenses": "No se pueden crear licencias sin conexión para licencias sin restricciones.",
        "change": "Cambiar",
        "clear all": "Borrar todo",
        "clear all filters": "Borrar todos los filtros",
        "close": "Cerrar",
        "company settings": "Configuración de la empresa",
        "confirm": "Confirmar",
        "continue": "Continuar",
        "copied": "Copiado",
        "copy all": "",
        "copy to clipboard": "Copiar al portapapeles",
        "create": "Crear",
        "create role": "Crear función",
        "create task": "Crear tarea",
        "creating": "Creación",
        "default view": "Vista predeterminada",
        "delete": "Eliminar",
        "deleting": "Eliminación",
        "deselect all": "Deseleccionar todo",
        "device": "Dispositivo",
        "disable": "Desactivar",
        "disagree": "No estoy de acuerdo",
        "discard": "Descartar",
        "download": "",
        "edit": "Editar",
        "enable": "Habilitar",
        "export": "Exportar",
        "exporting": "Exportación",
        "filters": "Filtros",
        "finish": "",
        "find tool": "Buscar herramienta",
        "first page": "Primera página",
        "generate": "Generar",
        "generate codes": "",
        "go back": "Volver atrás",
        "import": "Importar",
        "importing": "Importación",
        "invite": "Invitar",
        "invite user": "Invitar a usuarios",
        "invite user to internal disabled": "Solo el administrador y los usuarios con niveles de acceso superiores pueden invitar a otros usuarios a las empresas internas.",
        "language": "Idioma",
        "last page": "Última página",
        "logout": "Cerrar sesión",
        "maximize details": "Maximizar detalles",
        "merge": "Fusionar",
        "merging": "Fusión",
        "minimize details": "Minimizar detalles",
        "more actions": "Más acciones",
        "more filters": "Más filtros",
        "more options": "Más opciones",
        "move": "Mover",
        "moving": "Traslado",
        "next": "Siguiente",
        "next month": "El mes que viene",
        "next page": "Página siguiente",
        "no actions available": "No hay acciones disponibles",
        "no permission": "Necesitas el permiso «{{permissionName}}».",
        "no permissions": "Necesitas los siguientes permisos: {{permissionNames}}.",
        "notify when done": "Notificarme cuando haya terminado",
        "number of selected companies": "{{companyCount}} de {{companyName}}",
        "only essential": "Solo lo esencial",
        "open fota web": "Open FOTA WEB",
        "pages of": "de {{total}}",
        "previous month": "Mes anterior",
        "previous page": "Página anterior",
        "print": "",
        "receive devices": "Recibir dispositivos",
        "refresh page": "Actualizar",
        "reject all": "Rechazar todo",
        "reset to default": "Restablecer valores predeterminados",
        "retry failed tasks": "Reintentar tareas fallidas",
        "retrying": "Reintentando",
        "return home": "Vamos a casa.",
        "revert manual level change": "Revertir el cambio de nivel manual",
        "rows count per page": "Número de filas por página",
        "rows selected": "{{count}} Seleccionado",
        "save": "Guardar",
        "saving": "",
        "see all": "Ver todo",
        "select all": {
            "devices": "Seleccionar todos los {{count}} dispositivos",
            "tasks": "Seleccionar todas las {{count}} tareas pendientes/en ejecución",
            "groups": "Seleccionar todos los {{count}} grupos",
            "files": "Seleccionar todos los {{count}} archivos",
            "companies": "Seleccionar todas las {{count}} empresas",
            "users": "Seleccionar todos los {{count}} usuarios"
        },
        "select columns to show": "Seleccionar columnas para mostrar",
        "selected page is first": "La página seleccionada es la primera",
        "selected page is last": "La página seleccionada es la última",
        "select rows": "Seleccionar filas",
        "send code": "Enviar código",
        "settings": "Configuración",
        "show me": "Mostrar",
        "show more": "Mostrar más",
        "synchronize": "Sincronizar",
        "table statistics": "Estadísticas de la tabla",
        "table view": "Vista de tabla",
        "transfer": "Transferencia",
        "transferring": "Transferencia",
        "transfer my devices": "Transferir mis dispositivos",
        "undo": "Deshacer",
        "upload": "Carga",
        "upload file": "Subir nuevo archivo",
        "user": "Usuario",
        "verify": "Verificar",
        "yes": "Sí"
    },
    "Cookies": {
        "always active": "Siempre activo",
        "analytics cookies": "Cookies analíticas",
        "analytics cookies description": "Estos rastreadores se utilizan para realizar análisis que nos ayudan a recopilar datos que nos permiten comprender cómo interactúan los usuarios con nuestros sitios web. Esta información nos permite mejorar el contenido y crear mejores funciones que mejoran la experiencia del usuario. Esta categoría de cookies se puede desactivar.",
        "cookie banner message": "Nosotros y terceros seleccionados utilizamos cookies o tecnologías similares con fines técnicos y, con su consentimiento, para otros fines especificados en el ",
        "cookie modal title": "Utilizamos cookies",
        "cookie policy": "Política de cookies",
        "essential cookies": "Cookies esenciales",
        "essential cookies description": "Estos rastreadores se utilizan para actividades que son estrictamente necesarias para operar o prestar el servicio que nos ha solicitado y, estas cookies no recopilan información sobre usted que pueda utilizarse con fines de marketing y no recuerdan dónde ha estado en Internet. Esta categoría de cookies no se puede desactivar."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Elementos esenciales para la actualización remota de dispositivos",
                "Standard": "Automatización e integración avanzadas",
                "Premium": "Escalabilidad empresarial y acceso anticipado a las actualizaciones"
            },
            "resource limit types": {
                "Companies": "Empresas",
                "Users": "Usuarios",
                "ConfigurationFiles": "Archivos de configuración"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Tan pronto como FOTA WEB detecte las configuraciones, podrá ver la lista aquí.",
                "firmware versions": "Tan pronto como FOTA WEB detecte las versiones de firmware, podrá ver la lista aquí."
            },
            "title": {
                "configurations": "No se han detectado configuraciones",
                "firmware versions": "No se han detectado versiones de firmware",
                "news": "No hay noticias que mostrar"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Hoy",
                "7": "7 días",
                "30": "30 días",
                "90": "90 días"
            },
            "period": "Periodo"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Nos gustaría recordarle que, para los usuarios invitados después del 7 de enero de 2025, la autenticación de dos factores (2FA) será obligatoria inmediatamente después de la activación de la cuenta. La autenticación de dos factores está disponible mediante verificación por correo electrónico o una aplicación de autenticación.",
                "2": "Nos gustaría informarle sobre el mantenimiento previsto de FOTA WEB que tendrá lugar el 3 de junio de 2025 a partir de las 05:00 UTC. Tenga en cuenta que durante el mantenimiento todos los servicios estarán indisponibles, incluyendo la interfaz de usuario, el acceso a la API, la ejecución de tareas, los servicios OBD y CAN. El tiempo estimado de indisponibilidad del servicio es de 1 hora.",
                "3": "<section><p>Nos complace anunciar una importante mejora en la función Device Unlocker (Desbloqueo de dispositivos) de FOTA WEB:</p></section><section><p>Ahora, todos los roles de usuario pueden desbloquear dispositivos directamente, sin necesidad de ponerse en contacto con el servicio de asistencia técnica a través del servicio de ayuda. </p><p>Detalles clave:</p><ul><li>Los usuarios pueden desbloquear el mismo dispositivo hasta 3 veces en un periodo de 24 horas.</li><li>Una vez alcanzado el límite, la opción de desbloqueo se desactivará temporalmente durante 24 horas.</li><li>Si se supera el límite de desbloqueos, aparecerá un mensaje de error. Esta actualización reduce significativamente los tiempos de espera y le ofrece un mayor control sobre la gestión de su flota.</li></ul></section><section><a>Aprenda a utilizar la función</a></section>",
                "4": "<section><h3>Nuevas estadísticas de dispositivos</h3><p>Obtenga una mejor visión de la actividad de sus dispositivos con dos nuevos widgets:</p><p><strong>Dispositivos activados</strong>: Esta nueva estadística le muestra cuántos dispositivos se han activado (conectado) durante varios periodos: hoy, 7 días, 30 días o 90 días. </p><p><strong>Dispositivos importados</strong>: Del mismo modo, la nueva estadística Dispositivos importados realiza un seguimiento de cuántos dispositivos se han importado hoy, en los últimos 7 días, 30 días o 90 días.</p></section><section><h3>Presentación del widget Tareas</h3><p>Realice un seguimiento de sus operaciones con el nuevo widget Tareas:</p><p><strong>Tareas en cola</strong>: Vea un recuento claro de sus tareas actualmente pendientes.</p><p><strong>Resumen de tareas</strong>: obtenga un desglose de la distribución de sus tareas por período (7 días, 30 días o 90 días) y estado. Esto incluye tareas completadas, completadas con errores o fallidas.</p></section><section><h3>Resúmenes más inteligentes del firmware y la configuración</h3><p>Hemos perfeccionado los widgets de versiones de firmware y configuraciones:</p><ul><li>Hemos eliminado las estadísticas «Desconocidas» para que los datos sean más claros.</li><li>La interfaz de usuario ahora muestra con mayor claridad los nombres del firmware y la configuración, así como su recuento.</li><li>Inicialmente verá las 5 versiones o configuraciones principales, con una opción para «Mostrar más» y ver hasta 100 entradas diferentes. </li><li>Al pasar el cursor y hacer clic en un firmware o una configuración específicos, se le dirigirá a la «página de dispositivos» y se aplicará un filtro.</li></ul></section><section><h3>Widget de noticias mejorado</h3><p>¡Manténgase informado de un vistazo! El widget de noticias tiene un nuevo aspecto y ahora también puede hacer clic en cualquier noticia para leer la información completa. </p></section><section><h3>Estado del dispositivo mejorado</h3><p>El widget de estado del dispositivo se ha actualizado visualmente para mayor claridad. Además, ahora puede pasar el cursor por encima del estado de un dispositivo y hacer clic en él para filtrar los dispositivos con el estado correspondiente en la página «Dispositivos».</p></section><section><p>Esperamos que estas actualizaciones faciliten aún más sus tareas diarias y le proporcionen información más valiosa. ¡Háganos saber lo que piensa!</p></section>",
                "5": "<section><h3>Cambios previstos en la API</h3></section> <section><p>El <strong>24 de septiembre de 2025</strong>, eliminaremos el campo «role» de las respuestas que devuelven la entidad de usuario (por ejemplo, los puntos finales GET /users o GET /users/{userId}). Este cambio se realiza para allanar el camino hacia un sistema de permisos más robusto y flexible en FOTA WEB.</p></section> <section><h3>Avance: Roles y permisos</h3></section> <section><p> Somos conscientes de que el sistema de roles actual no ofrece la flexibilidad que usted necesita. Nuestro equipo de desarrollo está trabajando intensamente en una nueva función de <strong>gestión de roles y permisos</strong> que le permitirá crear roles con un control granular sobre los permisos.</p></section> <section><p>Este nuevo sistema le permitirá asignar roles estáticos a los usuarios o adaptar los permisos a sus necesidades específicas, así como crear roles personalizados. Estamos muy ilusionados con esta novedad y esperamos poder compartir más detalles sobre la gestión de roles y permisos cuando estén disponibles.</p></section>",
                "6": "<section><p>Nos complace anunciar el lanzamiento de la nueva función <strong>«Roles y permisos»</strong>, diseñada para ofrecerle un control preciso sobre el acceso de los usuarios dentro de FOTA WEB. Esta funcionalidad le permite definir las capacidades de los usuarios mediante <strong>roles</strong>, que son conjuntos de <strong>permisos</strong> específicos (por ejemplo, «Crear tarea», «Invitar a usuario»). La función incluye <strong>roles estáticos</strong> inmutables (administrador, usuario e invitado) para la seguridad básica, junto con <strong>roles personalizados</strong> que solo los usuarios <strong>de nivel Premium de empresa</strong> pueden crear o editar. Los permisos ahora se clasifican en áreas clave como dispositivos, tareas y usuarios, y se pueden ver al pasar el cursor sobre el «recuento de permisos» en la sección de administración. <strong>A todos los usuarios existentes creados antes de esta actualización se les ha asignado automáticamente el rol de «Administrador», lo que garantiza que conserven toda la gama de acciones que podían realizar anteriormente.</strong></p></section> <section><p>Esta actualización garantiza una mayor seguridad y una mejor distribución de la carga de trabajo. Los roles ahora son específicos de cada empresa y no se pueden heredar entre estructuras empresariales. Tenga en cuenta que siempre se debe asignar un rol al invitar o trasladar a un usuario a una empresa, y que los roles con asignaciones de usuarios activas no se pueden eliminar. Ahora puede utilizar el <strong>nuevo filtro «Rol»</strong> en la página <strong>Usuarios</strong> para facilitar la gestión. Explore hoy mismo la sección «Roles y permisos» para configurar el acceso adaptado a las necesidades de su organización.</p></section> <section><p>Para obtener una guía detallada sobre la gestión de usuarios y roles, visite <a>la página wiki</a>.</p></section>",
                "7": "<section><p>Nos complace presentar una nueva y potente forma de gestionar tus tareas con la función <strong>Programar por fecha</strong>, que te ofrece una mayor precisión para los trabajos urgentes.</p></section> <section><h3>Aspectos destacados</h3></section> <section><ul><li><strong>Plazos específicos</strong>: ahora puede programar tareas para una <strong>fecha específica o un intervalo de fechas</strong> utilizando la nueva opción «Programar por fecha».</li> <li><strong>Comportamiento predeterminado sin cambios</strong>: la conocida función <strong>Programar por hora</strong> sigue estando totalmente disponible. </li> <li><strong>Estado de caducidad</strong>: las tareas que no se completen en la fecha establecida ahora cambiarán automáticamente a <strong>Caducadas</strong>, acompañadas del mensaje: <strong>«La tarea no se completó durante el plazo establecido».</strong></li> <li><strong>Sincronización centrada en el usuario</strong>: todas las programaciones se crean en función de <strong>su hora local</strong>.</li></ul></section> <section><h3>Cómo funciona</h3></section> <section><p>Al configurar la tarea <strong>«Programar por fecha»</strong>:</p> <ul><li>Seleccionará una <strong>«Fecha de inicio»</strong> y una <strong>«Fecha de finalización»</strong> a través del componente de selección de fecha.</li> <li>El selector de fecha respeta el límite de tiempo de caducidad de las tareas a nivel de la empresa.</li></ul></section><section><p>La funcionalidad <strong>Programar por fecha</strong> es actualmente exclusiva de los niveles superiores de la empresa y no está disponible para el nivel <strong>Básico</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Autenticación de dos factores (2FA) obligatoria para los nuevos usuarios a partir del 7 de enero de 2025",
                "2": "Mantenimiento planificado para el 3 de junio de 2025",
                "3": "Nueva actualización de funciones: desbloqueo de dispositivos más sencillo para todos los usuarios",
                "4": "¡Descubra las novedades en su panel de control!",
                "5": "Importante: próximos cambios en la API y avance de funciones y permisos",
                "6": "Nueva función ya disponible: control mejorado con «funciones y permisos»",
                "7": "Nueva función: mayor flexibilidad con la programación de tareas por fecha",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Publicado el",
        "take me there": "Llévenme allí",
        "tasks": {
            "current": "Actual",
            "status": {
                "completed": "Completado",
                "completed_with_errors": "Completado con errores",
                "failed": "Fallido",
                "no tasks": "Sin tareas"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 días",
                "tooltipTitle": "Últimos 7 días"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 días",
                "tooltipTitle": "Últimos 30 días"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 días",
                "tooltipTitle": "Últimos 90 días"
            }
        },
        "title": {
            "activated": "Dispositivos activados",
            "configurations": "Configuraciones",
            "device status": "Estado del dispositivo",
            "firmware versions": "Versiones de firmware",
            "imported": "Dispositivos importados",
            "news": "Noticias",
            "queued tasks": "Tareas en cola",
            "refreshed every hour": "Actualizado cada hora",
            "resource limits": "Límites de recursos",
            "task overview": "Resumen de tareas",
            "tasks": "Tareas"
        },
        "tooltips": {
            "activated": "Número de dispositivos que se conectaron a FOTA WEB por primera vez durante el periodo seleccionado (hoy, últimos 7 días, últimos 30 días, últimos 90 días).",
            "configurations": "Muestra la distribución de los nombres de los archivos de configuración que se han cargado en sus dispositivos. Se muestran hasta 100 nombres de archivos únicos.",
            "firmware versions": "Muestra la distribución de las versiones de firmware notificadas por los dispositivos conectados. Se muestran hasta 100 versiones únicas.",
            "imported": "Número de dispositivos añadidos a su cuenta durante el periodo seleccionado (hoy, últimos 7 días, últimos 30 días, últimos 90 días)."
        }
    },
    "Date picker": {
        "disableFuture": "Fecha no válida",
        "disablePast": "Fecha no válida",
        "invalidDate": "Fecha no válida",
        "maxDate": "Fecha incorrecta",
        "minDate": "Fecha incorrecta",
        "shouldDisableDate": "Fecha no válida",
        "shouldDisableMonth": "Fecha no válida",
        "shouldDisableYear": "Fecha no válida"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Añadir nuevo dispositivo",
        "add new device description": "Añada uno o varios dispositivos nuevos a la empresa y al grupo seleccionados. Solo los dispositivos heredados, como FM o FMA, deben importarse marcando la casilla «Importar como dispositivos heredados».",
        "add new device legacy title": "Importación como dispositivos heredados.",
        "add new device legacy description": "Establezca «Creado el» en 2016.01.01 y «Modelo» en Legacy.",
        "add new product code": "Añadir nuevo código de producto",
        "add new product code description": "Añada un nuevo código de producto de dispositivo y vincúlelo al paquete CAN disponible.",
        "all permissions": "Todos los permisos",
        "assign access group": "",
        "assign can package description": "Elija un tipo de paquete y asígnelo a todos los dispositivos seleccionados.",
        "assign role": "Asignar función",
        "attribute value": "Valor del atributo",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Iniciar descarga",
        "by date": "Por fecha",
        "by time": "Por tiempo",
        "can adapter": "Adaptador CAN",
        "cancel pending tasks": "Cancelar tareas pendientes del mismo tipo de tarea",
        "cancel tasks": "Cancelar tareas",
        "cancel tasks in group": {
            "alert title": "Esta acción tardará varios minutos en completarse.",
            "banner description": "Para ver el estado actualizado de las tareas, consulte los detalles del grupo de tareas o actualice la página.",
            "banner title": "Esta acción tardará varios minutos en completarse, dependiendo del número de tareas.",
            "description": "Al hacer clic en «Aceptar», se cancelarán todas las tareas pendientes y en ejecución. ¿Está seguro de que desea continuar?",
            "title": "¿Cancelar todas las tareas del grupo?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "Correo electrónico del representante del cliente",
        "companies": "Empresas",
        "company": "Empresa",
        "company level": {
            "Basic": "Básico",
            "Internal": "Interno",
            "Premium": "Premium",
            "Standard": "Estándar"
        },
        "company level change description": "Actualice el nivel de una empresa seleccionando el nuevo nivel y proporcionando una explicación del motivo. No es posible bajar el nivel de una empresa. Todas las fechas están en UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Esta acción restablecerá el nivel de la empresa al nivel asignado automáticamente «{{companyLevel}}». ¿Está seguro de que desea continuar?",
                "title": "¿Revertir el cambio de nivel manual?"
            },
            "description": "Al revertir, el nivel de la empresa volverá al nivel asignado automáticamente.",
            "title": "Este nivel de empresa se actualizó manualmente hasta {{expirationDate}}."
        },
        "company level type": "Tipo de nivel de empresa",
        "company name": "Nombre de la empresa",
        "company statistics": {
            "child companies": "Número de empresas filiales",
            "devices": "Recuento de dispositivos",
            "files": "Recuento de archivos",
            "groups": "Recuento de grupos de dispositivos",
            "tasks": "Recuento de tareas",
            "users": "Número de usuarios"
        },
        "company type": {
            "All": "",
            "Client": "Cliente",
            "Internal": "Interno",
            "Virtual": "Virtual"
        },
        "configuration": "Configuración",
        "confirmations": {
            "are you sure": "¿Estás seguro?",
            "are you sure you wish to continue": "¿Está seguro de que desea continuar?",
            "assign can package confirmation": "¿Está seguro de que desea asignar el paquete seleccionado al número de dispositivos especificado?",
            "cancel task confirmation": {
                "first part": "¿Está seguro de que desea cancelar el número especificado de tareas?",
                "second part": "Si es así, introduzca el número de tareas afectadas y haga clic en «Confirmar»."
            },
            "create task confirmation": "¿Está seguro de que desea crear una tarea para el número de dispositivos especificado?",
            "delete resource confirmation": {
                "first part": "¿Está seguro de que desea eliminar el número especificado de {{resource}}?",
                "second part": "Si es así, introduzca el número de {{resource}} afectados y haga clic en «Eliminar»."
            },
            "delete resources": {
                "companies": "empresas",
                "files": "archivos",
                "groups": "Grupos de dispositivos",
                "deviceModels": "modelos",
                "productCodes": "códigos de producto",
                "roles": "funciones",
                "users": "usuarios"
            },
            "description second part": "Si es así, introduzca el número de dispositivos afectados y haga clic en «Confirmar».",
            "export device data confirmation": "¿Está seguro de que desea exportar los datos de los dispositivos para el número especificado de dispositivos?",
            "file": "Introduzca el número de líneas que hay en el archivo",
            "filter": {
                "companies": "Introduzca el número de empresas filtradas",
                "devices": "Introduzca el número de dispositivos filtrados",
                "files": "Introduzca el número de archivos filtrados",
                "groups": "Introduzca el número de grupos de dispositivos filtrados",
                "productCodes": "Introduzca el número de códigos de producto filtrados",
                "tasks": "Introduzca el número de tareas filtradas",
                "users": "Introduzca el número de usuarios filtrados"
            },
            "id_list": {
                "companies": "Introduzca el número de empresas seleccionadas",
                "devices": "Introduzca el número de dispositivos seleccionados",
                "files": "Introduzca el número de archivos seleccionados",
                "groups": "Introduzca el número de grupos de dispositivos seleccionados",
                "productCodes": "Introduzca el número de códigos de producto seleccionados",
                "tasks": "Introduzca el número de tareas seleccionadas",
                "users": "Introduzca el número de usuarios seleccionados"
            },
            "merge companies confirmation": "Estás a punto de fusionar las empresas {{sourceCompany}} y {{targetCompany}}.",
            "move companies confirmation": "Está a punto de trasladar {{sourceCompany}} a la empresa {{targetCompany}}.",
            "move devices confirmation": "¿Está seguro de que desea trasladar el número especificado de dispositivos a otra empresa?",
            "number of lines": "Número de líneas",
            "selected 20 or more devices": "Ha seleccionado 20 o más dispositivos...",
            "transfer devices confirmation": "¿Está seguro de que desea transferir el número especificado de dispositivos a otra empresa?"
        },
        "confirm cannot revert": "Esta acción es irreversible.",
        "confirm merge companies": "¿Está seguro de que desea fusionar estas empresas?",
        "count": "Contar",
        "create company": "Crear empresa",
        "create company description": "Crear una nueva empresa bajo la empresa matriz seleccionada.",
        "create desktop license": "Crear licencia de escritorio",
        "create desktop license description": "Emite una nueva licencia FOTA Desktop en línea para la empresa cliente con su IP, clave de hardware y fecha de caducidad (máximo 2 años).",
        "create group": "Crear grupo",
        "create group description": "Organiza los dispositivos en grupos para simplificar la gestión y la asignación masiva.",
        "create model": "Crear modelo",
        "create model description": "Cree un nuevo modelo de dispositivo especificando el nombre, la plataforma y la compatibilidad con la TCT web.",
        "create offline license": "Crear licencia sin conexión",
        "create or edit group description": "El firmware y la configuración se pueden asignar al grupo. Una vez hecho esto, se generarán tareas de actualización del firmware y/o la configuración para todos los miembros del grupo (dispositivos).",
        "create role": "Crear función",
        "create role description": "Cree una nueva función asignándole un nombre y una descripción, seleccionando una empresa y asignándole permisos específicos.",
        "create smart group": "Crear grupo inteligente",
        "create smart group banner message": "",
        "create smart group description": "Los archivos de firmware y configuración se pueden asignar al grupo para cada plataforma. Una vez asignados los archivos, se generarán tareas de actualización para todos los dispositivos del grupo.",
        "create task description first step": "Cree una amplia variedad de tareas, desde actualizar la configuración o el firmware hasta recibir registros, configuraciones y mucho más de dispositivos seleccionados o filtrados. Además, puede programar las tareas creadas para su comodidad.",
        "create task description last step": "Asegúrese de que la siguiente información sea correcta antes de crear la tarea.",
        "current level": "Nivel actual",
        "custom resource limits": {
            "at least one limit must be higher": "Al menos un límite debe ser superior al valor predeterminado del nivel Premium.",
            "configuration files per device": "Archivos de configuración por dispositivo.",
            "confirmation modal description": "¿Está seguro de que desea cambiar los siguientes límites de recursos de la empresa «{{companyName}}»?",
            "confirmation modal title": "¿Cambiar los límites de recursos de la empresa?",
            "count": {
                "companies count": "Número de empresas: {{number}}",
                "configuration files per device count": "Número de archivos de configuración por dispositivo: {{number}}",
                "tasks per group count": "Número de tareas por grupo: {{number}}",
                "users count": "Número de usuarios: {{number}}"
            },
            "explanations": {
                "companies": "Número total de empresas secundarias que se pueden crear en la jerarquía de la empresa.",
                "configuration files per device": "El número de archivos de configuración que se pueden almacenar es de 1 dispositivo por cada archivo de configuración. La cantidad mínima garantizada de archivos de configuración es de 100 por cada nivel de empresa.",
                "tasks per group": "Número de tareas que pueden estar en un grupo de tareas.",
                "users": "Número total de usuarios que se pueden crear en la jerarquía de la empresa."
            },
            "main modal description": "Establezca una cantidad personalizada de recursos para diferentes tipos de recursos, como empresas, usuarios, tareas por grupo de tareas o archivos de configuración. Los recursos personalizados estarán activos hasta que expire el nivel Premium o se restablezcan manualmente.",
            "resources limit type": "Tipo de límite de recursos",
            "revert custom resource limits": "Revertir los límites de recursos personalizados",
            "revert custom resource limits description": "Al restablecer todos los límites, se establecerán los valores predeterminados de los recursos y se cambiará el nivel de la empresa a Premium.",
            "revert custom resource limits description confirmation": "Esta acción restablecerá los límites de recursos a los asignados automáticamente para el nivel «Premium». ¿Está seguro de que desea continuar?",
            "revert custom resource limits title": "Los límites de recursos de esta empresa se establecieron manualmente.",
            "revert custom resource limits title confirmation": "¿Revertir los límites de recursos personalizados?",
            "tasks per group": "Tareas por grupo"
        },
        "date range": "Intervalo de fechas",
        "date to": "a",
        "delete companies": "Eliminar empresas",
        "delete deviceModels": "Eliminar modelos",
        "delete files": "Eliminar archivos",
        "delete file warning": "Al eliminar archivos se cancelarán las tareas y los grupos de tareas relacionados.",
        "delete groups": "Eliminar grupos de dispositivos",
        "delete productCodes": "Eliminar códigos de producto",
        "delete roles": "Eliminar roles",
        "delete tasks and history": "",
        "delete users": "Eliminar usuarios",
        "description": "Descripción",
        "desktop license delete description": "¿Está seguro de que desea eliminar la licencia de escritorio «{{name}}»?",
        "desktop license name": "Nombre de la licencia de desktop",
        "device identifier": "Identificador de dispositivos",
        "device transfer": {
            "main": {
                "description": "Transfiere dispositivos seleccionados o filtrados a una empresa no relacionada utilizando un token generado por la empresa receptora.",
                "title": "Transferencia de dispositivos"
            },
            "receive devices": {
                "copy token": "Copie y envíe el token generado a la persona responsable de transferir los dispositivos de su empresa a la suya.",
                "description": "Cree un token de dispositivo receptor y envíelo a la empresa de transferencia.",
                "token info": "El token es de un solo uso y caduca a los 21 días."
            },
            "transfer devices": {
                "confirmation": "¿Está seguro de que desea transferir los dispositivos a la siguiente empresa?",
                "device token": "El token de transferencia del dispositivo debe obtenerse del administrador de la empresa a la que desea transferir sus dispositivos.",
                "transfer from file": "Cargue un archivo con la lista de dispositivos (IMEI) que desea transferir desde su empresa a la empresa cuyo token acaba de introducir."
            }
        },
        "device transfer token": "Token de transferencia de dispositivos",
        "downgrading company level is not possible": "No es posible bajar de categoría a nivel de empresa",
        "download sample file message": "Descargue una <1>plantilla CSV de muestra</1> para ver un ejemplo del formato requerido.",
        "edit group banner message": "Cambiar el firmware y/o los archivos de configuración cancelará todas las tareas pendientes anteriores del mismo tipo.",
        "edit group description": "Modifique la configuración de este grupo de dispositivos.",
        "edit role description": "Personaliza el nombre, la descripción y los permisos de los roles. La empresa asignada no se puede cambiar.",
        "edit smart group description": "Los archivos de firmware y configuración se pueden asignar o cambiar al grupo para cada plataforma. Una vez asignados o cambiados los archivos, se generarán tareas de actualización para todos los dispositivos del grupo.",
        "email": "Correo electrónico",
        "enter": "Entrar",
        "enter code": "Introducir código",
        "enter description": "Introducir descripción",
        "enter name": "Introduzca el nombre",
        "example": "Por ejemplo:",
        "expires at": "Caduca en",
        "explanation": "Explicación",
        "export device data": "Exportación de datos de dispositivos",
        "export device description": "",
        "export file format": "Formato de archivo de exportación",
        "feature": "Característica",
        "feature control": "Control de funciones",
        "field disabled until company selected": "Este campo está desactivado hasta que se seleccione la empresa.",
        "firmware": "Firmware",
        "files to download": "Archivos para descargar",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "La lista de autorizaciones 1-Wire cargada se clasificará automáticamente para mejorar la velocidad y la precisión de la funcionalidad.",
                "bluetooth_authorization_list": "La lista de autorizaciones Bluetooth cargada se clasificará automáticamente para mejorar la velocidad y la precisión de la funcionalidad."
            },
            "endings": {
                "file": "archivo",
                "files": "archivos"
            },
            "fail": {
                "multiple": "{{failCount}} de {{totalCount}} {{fileEnding}} no se han subido debido a un error.",
                "single": "{{failCount}} de {{totalCount}} {{fileEnding}} no se ha subido debido a un error."
            },
            "success": {
                "multiple": "Todos los archivos se han añadido correctamente a las empresas seleccionadas.",
                "single": "Todos los archivos se han añadido correctamente a la empresa seleccionada."
            }
        },
        "filtered": "Filtrado",
        "filtered companies": "Empresas filtradas",
        "filtered devices": "Dispositivos filtrados",
        "filtered files": "Archivos filtrados",
        "filtered groups": "Grupos filtrados",
        "filtered tasks": "Tareas filtradas",
        "filtered users": "Usuarios filtrados",
        "find tool": {
            "device": {
                "error not valid": "El IMEI debe constar de 15 caracteres",
                "error subtitle": "No se ha encontrado el dispositivo. Intente introducir un IMEI diferente.",
                "error title": "No se ha encontrado ningún dispositivo",
                "link": "Ir al dispositivo",
                "no permission": "No tienes permiso para ver este dispositivo."
            },
            "user": {
                "error not valid": "Formato de correo electrónico no válido",
                "error subtitle": "Usuario no encontrado. Intente escribir una dirección de correo electrónico diferente.",
                "error title": "No se ha encontrado ningún usuario",
                "link": "Ir al usuario",
                "no permission": "No tienes permiso para ver este usuario."
            }
        },
        "firmware date": "Fecha del firmware",
        "from form": "Desde el formulario",
        "from file": "Desde el archivo",
        "general": "General",
        "gsm_number": "Número GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Restricción IMEI",
        "import device data": "Importar datos de dispositivos",
        "import device data description": "Importa los datos de los atributos seleccionados para los dispositivos de la lista proporcionada.",
        "import device data info": "Cada atributo tiene un límite máximo de caracteres que se muestra entre paréntesis. Si un atributo tiene más caracteres que el límite máximo, se acortará automáticamente hasta el límite máximo.",
        "import device data limit": "(máximo {{limit}} caracteres)",
        "imsi": "IMSI",
        "input text too long": "El texto es demasiado largo. Se permite un máximo de {{maxLength}} caracteres.",
        "invalid hardware key": "Formato de clave de hardware no válido",
        "invalid imei": "El IMEI no es válido",
        "invalid ipv4": "Formato IPv4 no válido",
        "invalid serial": "Número de serie no válido",
        "invalid value": "Valor no válido",
        "inverted selection": "Selección invertida",
        "invite user": "Invitar a usuarios",
        "invite user description": "Invite a un nuevo usuario a la empresa matriz seleccionada y establezca su función. Después de enviarla, el usuario tendrá 30 días para aceptar la invitación antes de que caduque.",
        "invite user max roles": "Se permite un máximo de 5 roles. Deseleccione uno para continuar.",
        "log files": "Archivos de registro",
        "make": "Crear",
        "manage permissions": "Gestiona todos los datos a nivel de cuenta y de sitio.",
        "maximum value is": "El valor máximo es {{value}}",
        "merge companies": "Fusionar empresas",
        "merge companies info": "Todos los recursos de la empresa de origen (dispositivos, grupos, archivos, empresas, usuarios con sus funciones) se trasladarán a la empresa de destino. Es posible que desee revisar las funciones de los usuarios antes de la fusión. La empresa de origen se eliminará posteriormente.",
        "merge companies disabled option": {
            "client to internal": "Las empresas de tipo cliente no se pueden fusionar con empresas de tipo interno.",
            "internal": "Las empresas de tipo interno no se pueden fusionar.",
            "lz code": "La empresa con código no se puede fusionar."
        },
        "minimum value is": "El valor mínimo es {{value}}",
        "move companies disabled option": {
            "internal": "Las empresas de tipo interno no se pueden trasladar."
        },
        "move device": "Mover dispositivo",
        "move device description": "Mueva los dispositivos seleccionados o filtrados a la empresa existente y/o al grupo en la jerarquía de la empresa.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Mover dispositivos",
        "name": "Nombre",
        "newest": "Desde lo más reciente",
        "no dropdown files": {
            "description": "Para seleccionar esta opción, cargue un nuevo archivo $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Lista de autorizaciones de 1 cable",
                "adas_firmware": "Firmware ADAS",
                "ble_fw": "Firmware BLE",
                "blue_nrg": "Firmware BlueNrg",
                "bluetooth_authorization_list": "Lista de autorizaciones Bluetooth",
                "can_chip_firmware": "Firmware del chip FM CAN",
                "carrier_advance_firmware": "Firmware Carrier Advance",
                "carrier_advance_settings": "Configuración Carrier Advance",
                "carrier_apx_firmware": "Firmware Carrier APX",
                "carrier_apx_settings": "Configuración de Carrier APX",
                "certificate": "Certificado TLS",
                "configuration": "Configuración",
                "dsm_firmware": "Firmware DSM",
                "dtb": "DTB",
                "firmware": "firmware",
                "fw_bundle": "Paquete de firmware",
                "gnssm_download_assistant": "Asistente de descarga GNSS-M",
                "gnssm_firmware": "Firmware GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Lista de escenarios de geovallas manuales",
                "meig_modem_firmware": "Firmware del módem MeiG",
                "netprisma_modem_firmware": "Firmware del módem NETPRISMA",
                "psub": "Suscripción",
                "quectel_modem_firmware": "Firmware del módem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "No hay archivos $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Ninguno",
        "obd oem": "OBD OEM",
        "offline license delete description": "¿Está seguro de que desea eliminar la licencia sin conexión «{{name}}»?",
        "oldest": "Desde el más antiguo",
        "only integers": "Solo son válidos los números enteros",
        "only numbers": "Solo son válidos los números",
        "optional": "Opcional",
        "other companies": "Otras empresas",
        "parent company": "Empresa matriz",
        "permission preset": "Permisos preestablecidos",
        "platform compatibility": {
            "banner text": "Algunos de los modelos de dispositivos seleccionados no son compatibles con el tipo de tarea seleccionado. Este tipo de tarea no se creará de forma predeterminada para los modelos de dispositivos incompatibles.",
            "compatible model devices": "Modelos de dispositivos compatibles",
            "count text": "Se creará una tarea para <1>{{compatibleCount}}</1> de los {{totalCount}} dispositivos.",
            "create tasks for incompatible devices": "Crea tareas para dispositivos incompatibles.",
            "devices from file": "Dispositivos desde el archivo",
            "platform": "Plataforma {{title}}",
            "task applies": "La tarea se aplica a",
            "task cannot be created": "No se pueden crear tareas para dispositivos de modelos incompatibles."
        },
        "receiving company": "Esta empresa recibirá sus dispositivos",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Esta acción tardará varios minutos en completarse.",
            "banner description": "Para ver el estado actualizado de las tareas, consulte los detalles del grupo de tareas o actualice la página.",
            "description": "Al pulsar «Aceptar» se volverán a intentar todas las tareas fallidas. ¿Está seguro de que desea continuar?",
            "title": "¿Reintentar todas las tareas del grupo?"
        },
        "revision": "Revisión",
        "revision value error": "El valor debe ser de dos dígitos (00 - 99).",
        "role name": "Nombre del rol",
        "root company": "Empresa matriz",
        "sales email": "Correo electrónico del director comercial",
        "scheduled time warning": "Las tareas con hora programada no cambian la configuración del tiempo de conexión FOTA del dispositivo. Las tareas se ejecutarán si el dispositivo se conecta a FOTA durante el intervalo de tiempo seleccionado. Asegúrese de que los dispositivos estén configurados para conectarse a FOTA WEB durante un periodo no inferior al intervalo de tiempo seleccionado.",
        "schedule task": "Programar tareas",
        "select": "Seleccionar",
        "select at least one": {
            "companies": "Seleccione al menos una empresa",
            "devices": "Seleccione al menos un dispositivo",
            "files": "Seleccione al menos un archivo",
            "groups": "Seleccione al menos un grupo",
            "tasks": "Seleccione al menos una tarea",
            "users": "Seleccione al menos un usuario."
        },
        "selected": "Seleccionado",
        "selected companies": "Empresas seleccionadas",
        "selected deviceModels": "Modelos seleccionados",
        "selected devices": "Dispositivos seleccionados",
        "selected files": "Archivos seleccionados",
        "selected groups": "Grupos de dispositivos seleccionados",
        "selected productCodes": "Códigos de productos seleccionados",
        "selected roles": "Funciones seleccionadas",
        "selected tasks": "Tareas seleccionadas",
        "selected users": "Usuarios seleccionados",
        "select company": "",
        "select group": "",
        "select time interval": "Seleccionar intervalo de tiempo",
        "selected time window": "Intervalo de tiempo seleccionado: {{fromDate}} a {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Selecciona los archivos disponibles para los dispositivos de la plataforma {{platformName}}.",
            "title": "Archivos de la plataforma {{platformName}}."
        },
        "sn": "N.º de serie",
        "specific": "Específico",
        "time period": "Periodo de tiempo",
        "time period custom": "Personalizado",
        "tls certificate transfer info": "",
        "token has expired": "El token ha caducado",
        "token is valid": "El token es válido",
        "transfer companies": "Empresas de transferencia",
        "transfer companies description": "Seleccione si desea mover o fusionar dos empresas. Algunas opciones son irreversibles.",
        "transfer devices": "Dispositivos de transferencia",
        "tri source": {
            "selected tab description": {
                "create task": "La tarea seleccionada se creará para los dispositivos seleccionados mediante la casilla de verificación.",
                "general": "La acción seleccionada se ejecutará en los dispositivos seleccionados mediante la casilla de verificación."
            },
            "filtered tab description": {
                "create task": "La tarea seleccionada se creará para los dispositivos filtrados utilizando uno o varios filtros disponibles.",
                "general": "La acción seleccionada se ejecutará en los dispositivos filtrados utilizando uno o varios filtros disponibles."
            },
            "from file tab description": {
                "create task": "La tarea seleccionada se creará para los dispositivos especificados en el archivo cargado.",
                "general": "La acción seleccionada se ejecutará en los dispositivos especificados en el archivo cargado."
            }
        },
        "unlocker": {
            "generate unlock key": "Generar clave de desbloqueo",
            "generate unlock key description": "Introduzca el «código de bloqueo» del dispositivo de TCT en el campo siguiente. Pulse el botón «Generar» para generar una clave de desbloqueo y utilícela en TCT para desbloquear su dispositivo.",
            "invalid lock code": "Código de bloqueo del dispositivo no válido.",
            "limit reached": "Ha alcanzado el número máximo de claves de desbloqueo generadas.",
            "lock code": "Código de bloqueo",
            "unlock key": "Clave de desbloqueo",
            "unlock key success message": "Clave de desbloqueo generada correctamente."
        },
        "upload file": "Subir archivo",
        "upload file description": "Cargue hasta {{count}} archivos a la vez utilizando el campo de arrastrar y soltar o seleccionándolos.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Las versiones de firmware 04.00.00 y superiores incluyen protección contra downgrade. Para obtener más detalles sobre los cambios en el firmware, consulte nuestra documentación en <1>Teltonika GPS Wiki</1>. Al pulsar el botón «Siguiente», acepta y comprende la información anterior.",
        "upload firmware unsupported info": "La actualización a esta versión no está disponible. Póngase en contacto con el servicio de asistencia de Teltonika o con su responsable comercial de Teltonika.",
        "use at least one filter": "Utilice al menos un filtro",
        "user": "Usuario",
        "valid until": "Válido hasta",
        "valid until date disable description": "Este campo solo se puede modificar cuando el periodo de tiempo está configurado como «Personalizado»",
        "vehicle model": "Modelo"
    },
    "Dropzone": {
        "add file": "Añadir archivo",
        "add files": "Añadir archivos",
        "drop file to upload": "Arrastra el archivo para subirlo",
        "drop files to upload": "Arrastra los archivos para subirlos",
        "error uploading the file": "Se ha producido un error al cargar el archivo",
        "file invalid type": "Se ha seleccionado un tipo de archivo no válido",
        "file successfully uploaded": "Archivo subido correctamente",
        "file syntax": "La sintaxis de los archivos es la siguiente:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Se ha alcanzado el límite máximo de archivos",
        "only one file can be attached": "Solo se puede adjuntar un archivo",
        "or drop file to upload": "O arrastre el archivo para cargarlo",
        "or drop files to upload": "O arrastre los archivos para subirlos",
        "rows detected": "Filas del archivo detectadas correctamente",
        "select file": "Seleccionar archivo",
        "select files": "Seleccionar archivos",
        "select file type": "Seleccione primero el tipo de archivo",
        "supported formats": "Formatos compatibles",
        "too long file name": "El nombre del archivo es demasiado largo. Se permite un máximo de {{maxLength}} caracteres.",
        "too many files description": "El resto de los archivos se pueden cargar después de cargar los archivos seleccionados.",
        "too many files title": "Hay un límite máximo de {{maxFiles}} archivos que se pueden adjuntar a la vez."
    },
    "Error": {
        "error": "Error",
        "message wait": "Prepárate hasta que solucionemos el error.",
        "title": "¡Ha ocurrido un error!"
    },
    "Feature highlight": {
        "got it": "Entendido",
        "new feature": "¡Nueva función!",
        "scenarios description": "Ahora, puede configurar uno de los siguientes escenarios en su dispositivo: exceso de velocidad, detección de colisiones o detección de remolque."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Estado",
        "all permissions": "Todos los permisos",
        "batch_id": "ID de lote",
        "company_id": "Empresa",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Creado por",
        "current_configuration": "Configuración",
        "current_firmware": "Firmware",
        "device_imei": "IMEI del dispositivo",
        "file type": "Tipo de archivo",
        "filtered by": "Filtrado por",
        "filters used": "Filtros utilizados",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Grupo",
        "id": "ID",
        "Invalid company": "Empresa no válida",
        "model": "Modelo",
        "model_platform": "Plataforma",
        "Multiple companies": "Varias empresas",
        "parent company": "Empresa matriz",
        "permission": "Permiso",
        "permission status": "Estado",
        "role": "Función",
        "spec_id": "Spec ID",
        "status_id": "Estado",
        "supported_task_type": "Tipo de tarea",
        "table filters": "Filtros de tabla",
        "task type": "Tipo de tarea",
        "task_queue": "Cola",
        "type": "Tipo",
        "user status": "Estado"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "El tamaño del archivo de firmware ADAS no puede ser cero.",
        "ADAS firmware is invalid.": "El firmware ADAS no es válido.",
        "All notifications were deleted.": "Se han eliminado todas las notificaciones.",
        "All notifications were marked as read.": "Todas las notificaciones se marcaron como leídas.",
        "At least one user role must be provided.": "Se debe proporcionar al menos un rol de usuario.",
        "Attributes length is invalid": "La longitud de los atributos no es válida.",
        "Banner was updated.": "",
        "Batch was discarded": "El lote fue descartado.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Se ha creado una tarea de actualización masiva de atributos. Los atributos de los dispositivos se actualizarán en breve.",
        "Bulk create job was created. Devices will be created shortly.": "Se ha creado una tarea de creación masiva. Los dispositivos se crearán en breve.",
        "Bulk create job was created. Tasks will be created shortly.": "Se ha creado una tarea de creación masiva. Las tareas se crearán en breve.",
        "Bulk delete job was created. Companies will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Las empresas se eliminarán en breve.",
        "Bulk delete job was created. Devices will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Los dispositivos se eliminarán en breve.",
        "Bulk delete job was created. Files will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Los archivos se eliminarán en breve.",
        "Bulk delete job was created. Groups will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Los grupos se eliminarán en breve.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Los códigos de producto se eliminarán en breve.",
        "Bulk delete job was created. Users will be removed shortly.": "Se ha creado una tarea de eliminación masiva. Los usuarios serán eliminados en breve.",
        "Bulk task create job was created. Tasks will be created shortly.": "Se ha creado una tarea masiva y las tareas aparecerán en breve. Las tareas se pueden encontrar en la página «Grupos de tareas», en los detalles del grupo de tareas.",
        "Bulk update job was created. Devices will be updated shortly.": "Se ha creado una tarea de actualización masiva. Los dispositivos se actualizarán en breve.",
        "Bulk update job was created. Tasks will be updated shortly.": "Se ha creado una tarea de actualización masiva. Las tareas se actualizarán en breve.",
        "Can adapter was added.": "Se ha añadido un adaptador.",
        "Can adapter was deleted.": "Se ha eliminado el adaptador.",
        "Can adapter was updated.": "Se ha actualizado el adaptador.",
        "Can chip firmware file size can't be zero": "El tamaño del archivo del firmware del chip no puede ser cero.",
        "Can chip firmware is invalid.": "El firmware del chip puede no ser válido.",
        "Cannot delete company. Company is not empty.": "No se puede eliminar la empresa. La empresa no está vacía.",
        "Cannot delete file. It is used by pending or running tasks.": "No se puede eliminar el archivo. Se utiliza para tareas pendientes o en ejecución.",
        "Cannot delete file. It is used by running tasks.": "No se puede eliminar el archivo. Se utiliza para ejecutar tareas.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "No se puede eliminar el código de producto asignado a los dispositivos.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Se ha superado el límite de empresas.",
        "Companies in the request must belong to the selected root.": "Las empresas de la solicitud deben pertenecer a la raíz seleccionada.",
        "Company merge job was created. It will be merged shortly.": "Se ha creado una tarea de fusión de empresas. La fusión se llevará a cabo en breve.",
        "Company name already exist.": "El nombre de la empresa ya existe.",
        "Company level change is not allowed.": "No se permiten cambios a nivel de empresa.",
        "Company level successfully changed": "Nivel de empresa cambiado con éxito.",
        "company level successfully reverted": "El nivel de la empresa se ha revertido con éxito al nivel asignado automáticamente.",
        "Company not allowed to be merged": "No se permite la fusión de empresas.",
        "company resource limits changed": "Se han modificado con éxito los límites de recursos de la empresa.",
        "Company was created.": "Se creó la empresa.",
        "Company was deleted.": "La empresa ha sido eliminada.",
        "Company was updated.": "La empresa se ha actualizado.",
        "compatibilities added": "{{count}} nuevas compatibilidades añadidas durante la sincronización.",
        "compatibilities synchronized": "Compatibilidades que faltaban sincronizadas con éxito.",
        "Configuration cannot have FOTA functionality disabled": "La configuración no puede tener desactivada la funcionalidad FOTA.",
        "Configuration file cannot contain duplicate parameters": "El archivo de configuración no puede contener parámetros duplicados.",
        "Configuration file size can't be zero": "El tamaño del archivo de configuración no puede ser cero.",
        "Configuration files count limit exceeded.": "Se ha superado el límite de archivos de configuración.",
        "Configuration version must be defined": "Se debe definir la versión de configuración.",
        "custom resource limits successfully reverted": "Los límites de recursos personalizados se han revertido con éxito a los límites asignados automáticamente.",
        "Custom roles feature is not enabled.": "La función de roles personalizados solo puede ser utilizada por usuarios con nivel Premium de empresa. Los roles personalizados creados anteriormente pueden eliminarse.",
        "desktop license added": "La licencia desktop «{{name}}» se ha añadido correctamente.",
        "Devices already are in target company": "Los dispositivos ya se encuentran en la empresa objetivo.",
        "Device already exists.": "El dispositivo ya existe.",
        "Device bulk attribute update file cannot be empty": "El archivo de actualización masiva de atributos de dispositivos no puede estar vacío.",
        "Device bulk attribute update file should be .csv": "El archivo de actualización masiva de atributos de dispositivos debe estar en formato .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Se ha alcanzado el límite de exportación de dispositivos. No se pueden exportar más de 100 000 dispositivos.",
        "Device import limit reached. You can not import more than 100 devices": "Se ha alcanzado el límite de importación de dispositivos. No se pueden importar más de 100 dispositivos.",
        "Device model and task type compatibility was updated.": "Se ha actualizado la compatibilidad entre modelos de dispositivos y tipos de tareas.",
        "Device model was created.": "Se ha creado el modelo de dispositivo.",
        "Device model was deleted.": "Se ha eliminado el modelo de dispositivo.",
        "Device model was updated.": "Se ha actualizado el modelo del dispositivo.",
        "Device not found": "Dispositivo no encontrado.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Se ha creado una tarea de transferencia de dispositivos. Los dispositivos se transferirán en breve.",
        "Device was added.": "Se ha añadido un dispositivo.",
        "Device was deleted.": "El dispositivo se ha eliminado.",
        "Device was updated.": "El dispositivo se ha actualizado.",
        "Email or password is incorrect.": "El correo electrónico o la contraseña que ha introducido son incorrectos.",
        "Failed to create Product code": "No se ha podido crear el código del producto.",
        "Failed to delete Product code": "No se ha podido eliminar el código del producto.",
        "Failed to import devices.": "No se han podido importar los dispositivos.",
        "Failed to Read Product code": "No se ha podido leer el código del producto.",
        "Failed to retry failed tasks": "No se han podido reintentar las tareas fallidas.",
        "Failed to update Product code": "No se ha podido actualizar el código del producto.",
        "Failed to update task for retry": "No se ha podido reintentar la tarea fallida.",
        "Field is not valid": "El campo no es válido.",
        "File description is too long. Max 255 characters allowed.": "La descripción del archivo es demasiado larga. Se permite un máximo de 255 caracteres.",
        "File exceeds entries limit of 10000.": "El archivo supera el límite de entrada de 10 000.",
        "File must not contain duplicated IMEIs": "El archivo no debe contener IMEI duplicados.",
        "File must not contain IMEIs that already exist in database.": "El archivo no debe contener IMEI que ya existan en la base de datos.",
        "File must not contain invalid IMEIs": "El archivo no debe contener IMEI no válidos.",
        "File name is too long. Max 255 characters allowed.": "El nombre del archivo es demasiado largo. Se permite un máximo de 255 caracteres.",
        "File name should not contain illegal characters or symbols": "El nombre del archivo no puede contener caracteres especiales.",
        "File not found": "Archivo no encontrado.",
        "File was deleted.": "El archivo se ha eliminado.",
        "File was successfully uploaded.": "El archivo se ha subido correctamente.",
        "File was updated.": "El archivo se ha actualizado.",
        "File was uploaded. Devices will be imported shortly.": "El archivo se ha subido. Los dispositivos se importarán en breve.",
        "File will be created shortly. Check files in a second.": "El archivo se creará en breve. Comprueba los archivos en un segundo.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "El tamaño del archivo de firmware no puede ser cero.",
        "First device in file not found.": "No se encuentra el primer dispositivo en el archivo.",
        "Forbidden": "Prohibido.",
        "Group name already exist.": "El nombre del grupo ya existe.",
        "Group was added.": "«{{group}}» creado correctamente.",
        "Group was created.": "Se ha creado un grupo.",
        "Group was deleted.": "El grupo ha sido eliminado.",
        "Group was updated.": "Se ha actualizado el grupo.",
        "Invalid device bulk update attribute": "Atributo de actualización masiva de dispositivos no válido.",
        "Invalid email address.": "Dirección de correo electrónico no válida.",
        "Invalid file contents": "Contenido de archivo no válido.",
        "Invalid file name": "Nombre de archivo no válido.",
        "Invalid invitation token.": "Token de invitación no válido.",
        "Invalid token": "Token no válido.",
        "Invalid token length": "Longitud de token no válida.",
        "Internal Server Error": "Error interno del servidor.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "Se ha eliminado la licencia.",
        "License was updated.": "Se ha actualizado la licencia.",
        "Maximum companies hierarchy depth exceeded": "Se ha superado la profundidad máxima de la jerarquía de empresas.",
        "Maximum device group size exceeded.": "Se ha superado el tamaño máximo del grupo de dispositivos.",
        "Method Not Allowed": "Método no permitido.",
        "Network Error": "Error de red.",
        "No changes made": "No se han realizado cambios.",
        "No resources found.": "No se han encontrado recursos.",
        "not allowed to affect batch": {
            "description": "Asegúrese de que controla la empresa del usuario que ha creado este grupo de tareas.",
            "title": {
                "approve": "No tienes permiso para aprobar este lote.",
                "discard": "No tienes permiso para descartar este lote."
            }
        },
        "Not Found": "No encontrado.",
        "Notification was deleted.": "Se ha eliminado la notificación.",
        "notify when done title": "Esto puede tardar un poco. Pulse el botón de abajo para cerrar esta pantalla y recibirá una notificación cuando haya terminado.",
        "Obd record was created.": "Se ha creado un registro OBD.",
        "Obd record was updated.": "Se ha actualizado el registro OBD.",
        "offline license added": "La licencia sin conexión «{{name}}» se ha añadido correctamente.",
        "Offline license was deleted.": "Se ha eliminado la licencia sin conexión.",
        "Only id_list source is supported.": "Solo se admite la fuente id_list.",
        "Only users with Teltonika email can be invited into internal companies.": "Solo los usuarios con correo electrónico de Teltonika pueden ser invitados a empresas internas.",
        "Only users with Teltonika email can be moved into internal companies.": "Solo los usuarios con correo electrónico de Teltonika pueden ser trasladados a empresas internas.",
        "Parent company cannot be a descendant of the updated company.": "La empresa matriz no puede ser descendiente de la empresa actualizada.",
        "Password reset link was sent to Your email.": "Se ha enviado un enlace para restablecer la contraseña a su correo electrónico.",
        "Password reset token is invalid, expired or related user no longer exists.": "El token de restablecimiento de contraseña no es válido, ha caducado o el usuario ya no existe.",
        "Password was changed.": "Se ha cambiado la contraseña.",
        "product code added": "El código de producto «{{code}}» se ha añadido correctamente.",
        "Product code is too long. Max 200 characters allowed.": "El código del producto es demasiado largo. Se permite un máximo de 200 caracteres.",
        "ProductCode already exists.": "El código del producto ya existe.",
        "ProductCode not found": "Código de producto no encontrado.",
        "Product code was deleted.": "El código del producto ha sido eliminado.",
        "Product code was updated.": "Se ha actualizado el código del producto.",
        "Retry failed tasks job was created": "Se ha creado una tarea para reintentar las tareas fallidas.",
        "Role cannot be set for an internal user.": "No se puede establecer un rol para un usuario interno.",
        "Role was created.": "Se ha creado el rol.",
        "Role was deleted.": "Se ha eliminado el rol.",
        "Role was updated.": "Se ha actualizado la función.",
        "selected company changed": "Se ha cambiado la empresa seleccionada.",
        "Selected firmware bundle is not supported by the device.": "El paquete de firmware seleccionado no es compatible con el dispositivo.",
        "Server Error": "Error del servidor.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "Se ha enviado un SMS.",
        "Something went wrong while saving a new password.": "Se ha producido un error al guardar una nueva contraseña.",
        "Successfully logged out.": "Cierre de sesión correcto.",
        "System Admin user level is required in order to perform this action.": "Para realizar esta acción se requiere un nivel de usuario de administrador del sistema.",
        "Target company cannot be a descendant of source company.": "La empresa de destino no puede ser descendiente de la empresa de origen.",
        "Task create limit exceeded.": "No se pueden crear grupos de tareas para más de 100 000 dispositivos.",
        "Task type is not retriable": "El tipo de tarea no se puede volver a intentar.",
        "Task was added.": "Se ha añadido una tarea.",
        "task was created": "La tarea se ha creado para {{imei}} («{{taskType}}»). La tarea se encuentra en la página «Dispositivos», en «Tareas», dentro de los detalles del dispositivo.",
        "Task was updated.": "Se ha actualizado la tarea.",
        "Tasks were approved": "Las tareas fueron aprobadas.",
        "The given data was invalid.": "Los datos proporcionados no eran válidos.",
        "time zone changed": "Se ha cambiado la zona horaria.",
        "Token cannot be null or empty": "El token no puede ser nulo ni estar vacío.",
        "token created": "Se ha creado correctamente el token API.",
        "Token has expired": "El token ha caducado.",
        "Token's and token's owner companies do not match": "Los tokens y las empresas propietarias de los tokens no coinciden.",
        "Token was deleted.": "El token ha sido eliminado.",
        "Too many resources in the request": "Demasiados recursos en la solicitud.",
        "Too Many Requests": "Demasiadas solicitudes.",
        "Transfer token created": "Token de transferencia creado.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "La autenticación de dos factores ya está activada para el usuario.",
        "Two factor authentication successfully disabled.": "Autenticación de dos factores desactivada correctamente.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "No se pueden enviar SMS. Este dispositivo no tiene asignado un número GSM.",
        "Unable to validate Your request.": "No se puede validar su solicitud.",
        "Unauthenticated.": "Sin autenticación.",
        "Unauthorized": "No autorizado.",
        "User access level is not valid": "El nivel de acceso del usuario no es válido",
        "User invitation was revoked": "Invitación cancelada correctamente.",
        "User invitation was re-sent": "Se ha vuelto a enviar la invitación al usuario.",
        "User is already in the system.": "El usuario ya está en el sistema.",
        "User was created.": "Se ha creado un usuario.",
        "User was deleted.": "El usuario ha sido eliminado.",
        "User was invited.": "Invitación de usuario enviada correctamente.",
        "User was updated": "Se ha actualizado el usuario.",
        "Users count limit exceeded.": "Se ha superado el límite de usuarios.",
        "Your password has been changed.": "Se ha cambiado su contraseña."
    },
    "General": {
        "0": "Usuario",
        "5": "Soporte técnico",
        "10": "Administrador",
        "15": "Administrador",
        "19": "",
        "20": "Usuario del sistema",
        "99": "Superusuario",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Creación de la empresa",
        "Company.Delete": "Eliminación de la empresa",
        "Company.Merge": "Fusión de empresas",
        "Company.Update": "Actualización de la empresa",
        "Device.Export": "Exportación de dispositivos",
        "Device.Read": "Lectura de dispositivos",
        "Device.SecretsRead": "",
        "Device.Transfer": "Transferencia de dispositivos",
        "Device.Unlock": "Desbloqueo de dispositivos",
        "Device.Update": "Actualización de dispositivos",
        "DeviceGroup.Create": "Creación de grupos de dispositivos",
        "DeviceGroup.Delete": "Eliminación de grupos de dispositivos",
        "DeviceGroup.Read": "Lectura de grupos de dispositivos",
        "DeviceGroup.Update": "Actualización de grupos de dispositivos",
        "File.Create": "Creación de archivos",
        "File.Delete": "Eliminación de archivos",
        "File.Download": "Descarga de archivos",
        "File.Read": "Lectura de archivos",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Actualización de archivos",
        "Role.Create": "Creación de roles",
        "Role.Delete": "Eliminación de roles",
        "Role.Read": "Lectura de roles",
        "Role.Update": "Actualización de funciones",
        "Task.Create": "Creación de tareas",
        "Task.Read": "Lectura de tareas",
        "Task.Retry": "Reintento de tareas",
        "Task.Update": "Actualización de tareas",
        "TaskGroup.Read": "Lectura de grupos de tareas",
        "TctIntegration.Access": "Integración TCT",
        "Token.Create": "Creación de tokens",
        "Token.Delete": "Eliminación de tokens",
        "Token.Read": "Lectura de tokens",
        "User.Create": "",
        "User.Delete": "Eliminación de usuarios",
        "User.Read": "Leído por el usuario",
        "User.Update": "Actualización de usuarios",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Lista de autorizaciones de 1 cable",
        "1_wire_authorization_list": "Lista de autorizaciones de 1 cable",
        "Active": "Activo",
        "adas_firmware": "Firmware ADAS",
        "apx_firmware": "Firmware APX",
        "assign can package": "Asignar paquete CAN",
        "assigned package": "Paquete asignado",
        "automatic": "Automático",
        "banner management": "",
        "batches": "Grupos de tareas",
        "black_box": "Caja negra",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Lista de autorizaciones Bluetooth",
        "bluetooth_authorization_list": "Lista de autorizaciones Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Incompatible",
                "true": "Compatible"
            },
            "web_editor_support": {
                "false": "TCT web no compatible",
                "true": "Compatible con la TCT web."
            }
        },
        "can": "CAN",
        "can adapter name": "Nombre del adaptador CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Configuración OEM",
        "can_debug_log": "Registro de depuración CAN",
        "can oem file package": "Paquete de archivos OEM",
        "can oem file vehicle": "Vehículo de archivos OEM",
        "can package": "Paquete OEM",
        "can program number": "Número de programa CAN",
        "can revision": "Revisión CAN",
        "can software date": "Fecha del software CAN",
        "can type": "Tipo CAN",
        "Cancelled": "Cancelado",
        "cancel task": "Cancelar tarea",
        "can_chip_firmware": "Firmware del chip FM CAN",
        "carrier_advance_firmware": "Firmware Carrier Advance",
        "carrier_advance_settings": "Configuración Carrier Advance",
        "carrier_apx_firmware": "Firmware Carrier APX",
        "carrier_apx_settings": "Configuración de Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Archivos del registrador de temperatura del Carrier",
        "certificate": "Certificado",
        "click for more details": "Haga clic para obtener más detalles",
        "client ip": "IP del cliente",
        "clone model": "Clonar modelo de dispositivo",
        "collapse menu": "Contraer menú",
        "companies": "Empresas",
        "company": "Empresa",
        "company level": "A nivel de empresa",
        "company type": "Tipo de empresa",
        "company name": "Nombre de la empresa",
        "Completed": "Completado",
        "Completed with errors": "Completado con errores",
        "configuration": "Configuración",
        "configuration_36": "Configuración (FM36)",
        "configuration_64": "Configuración (FMB64)",
        "crash_dump": "Registro de volcado de memoria",
        "created at": "Creado en",
        "created by": "Creado por",
        "custom": "Personalizado",
        "custom resource limits": "Límites de recursos personalizados",
        "dashboard": "Panel de control",
        "delete desktop license": "Eliminar licencia de escritorio",
        "delete offline license": "Eliminar licencia sin conexión",
        "desktopLicenses": "Licencias de desktop",
        "device_export_file_csv": "Archivo de exportación de dispositivos (.csv)",
        "device_export_file_xlsx": "Archivo de exportación de dispositivos (.xlsx)",
        "deviceModels": "Modelos",
        "deviceModelTaskCompatibilities": "Compatibilidades",
        "device_transfer_report": "Informe de transferencia de dispositivos",
        "device group": "Grupo",
        "DeviceImportFile": "Archivo de importación de dispositivos",
        "devices": "Dispositivos",
        "download file": "Descargar archivo",
        "download offline license": "Descargar licencia sin conexión",
        "dsm_firmware": "Firmware DSM",
        "dtb": "DTB",
        "edit compatibility": "Editar compatibilidad de dispositivos",
        "edit model": "Editar modelo de dispositivo",
        "edit company": "Editar empresa",
        "edit desktop license": "Editar licencia de desktop",
        "edit device": "Editar dispositivo",
        "edit file": "Editar archivo",
        "edit group": "Editar grupo",
        "edit in tct web": "Editar en la TCT web",
        "edit in tct web disabled": "La edición en la TCT web solo está disponible para el nivel Premium de empresa.",
        "edit product code": "Editar código de producto",
        "edit role": "Editar función",
        "edit smart group": "Editar grupo inteligente",
        "edit user": "Editar usuario",
        "Empty": "Vacío",
        "enter here": "Entrar aquí",
        "exception_info": "Información sobre excepciones",
        "Executing": "Ejecución",
        "expand menu": "Expandir menú",
        "Expired": "Caducado",
        "Factory": "",
        "Failed": "Fallido",
        "file": "Archivo",
        "file data": "Datos de archivos",
        "files": "Archivos",
        "file deleted": "El archivo se ha eliminado",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Paquete de firmware",
        "fw_bundle_ble": "Paquete: firmware BLE",
        "fw_bundle_ble_dtb": "Paquete: BLE DTB",
        "fw_bundle_can": "Paquete: firmware CAN",
        "fw_bundle_can_dtb": "Paquete: CAN DTB",
        "fw_bundle_dtb": "Paquete: DTB principal",
        "fw_bundle_mainfw": "Paquete: firmware principal",
        "generic": "",
        "global_configuration": "Configuración global",
        "global_firmware": "Firmware global",
        "gnssm_download_assistant": "Asistente de descarga GNSS-M",
        "gnssm_firmware": "Firmware GNSS-M",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "hardware key": "Llave de hardware",
        "id": "ID",
        "id_collection_file": "Archivo de recopilación de identificaciones",
        "imei restriction": "Restricción IMEI",
        "Inactive": "Inactivo",
        "Invalid": "No válido",
        "invalid model": "Modelo no válido",
        "invalid model_name": "Modelo no válido",
        "InvitationExpired": "Invitación caducada",
        "InvitationPending": "Invitación pendiente",
        "Legacy": "Legado",
        "legacy model": "Modelo heredado",
        "legacy model_platform": "Plataforma heredada",
        "legacy platform": "Plataforma heredada",
        "license has expired": "La licencia ha caducado",
        "loading": "Cargando",
        "log": "Registro",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Manual",
        "ManualGeofenceList": "",
        "manual geofence list": "Lista de escenarios de geovallas manuales",
        "manual_geofence_list": "Lista de escenarios de geovallas manuales",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Firmware del módem MeiG",
        "menu": "Menú",
        "modem version": "Versión módem",
        "netprisma_modem_firmware": "Firmware del módem NETPRISMA",
        "nmea_log": "Registro NMEA",
        "no": "No",
        "no results": "No se han encontrado resultados iniciales",
        "no results description": "Tan pronto como {{name}} se carguen en FOTA WEB, podrás ver los datos aquí",
        "not assigned": "Sin asignar",
        "not assigned configuration_file_id": "Configuración no asignada",
        "not assigned current_configuration": "Configuración no asignada",
        "not assigned current_firmware": "Firmware no asignado",
        "not assigned firmware_file_id": "Firmware no asignado",
        "not assigned group_id": "Grupo sin asignar",
        "not assigned model": "Modelo sin asignar",
        "not assigned spec_id": "Spec ID no asignada",
        "not assigned task_type": "Tipo de tarea no asignada",
        "obd_chip_firmware": "Firmware del chip FM OBD",
        "obd chip firmware version": "Versión del firmware del chip OBD",
        "Offline": "Sin conexión",
        "offline licenses": "Licencias sin conexión",
        "Online": "En línea",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "o",
        "other": "Otros",
        "Pending": "Pendiente",
        "Pending approval": "A la espera de aprobación",
        "permission disabled": "Desactivado",
        "permission enabled": "Habilitado",
        "productCodes": "Códigos de producto",
        "psub": "Archivo de suscripción",
        "quectel_fw": "Firmware del módem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware del módem Quectel",
        "resend invite": "Reenviar la invitación",
        "restricted": "Restringido",
        "retry": "Reintentar",
        "roles": "Funciones y permisos",
        "Running": "En funcionamiento",
        "RxAutoscan": "Recibir archivo CAN de escaneo automático",
        "RxBlackBox": "Recibir caja negra",
        "RxBluetoothAuthorizationList": "Recibir la lista de autorizaciones Bluetooth",
        "RxCanDebugLog": "Recibir registro de depuración CAN",
        "RxCarrierExtractions": "Descargar Carrier extractions",
        "RxCarrierLoggerFiles": "Descargar archivos del registrador de temperatura del Carrier",
        "RxConfiguration": "Recibir configuración",
        "RxCrashDump": "Recibir registro de volcado de memoria",
        "RxExceptionInfo": "Recibir información sobre excepciones",
        "RxLog": "Recibir registro interno",
        "RxManualGeofenceList": "Recibir lista de escenarios de geovallas manuales",
        "RxNmeaLog": "Recibir registro NMEA",
        "RxOneWireAuthorizationList": "Recibir la lista de autorizaciones 1-Wire",
        "RxWdLog": "Recibir registro de vigilancia (WD)",
        "select company": "Seleccionar empresa",
        "SetBindSim": "Vincula el dispositivo con la(s) tarjeta(s) SIM actual(es)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Desactivar función",
        "SetEnableFeature": "Habilitar función",
        "SetForceLockSim": "Bloqueo forzado de la tarjeta SIM",
        "SetUnbindSim": "Desvincular dispositivos con tarjetas SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Estado",
        "task details": "Detalles de la tarea",
        "task groups": "Grupos de tareas",
        "tasks": "Grupos de tareas",
        "tasksCompatibility": "Compatibilidad de tareas",
        "task type": "Tipo de tarea",
        "Tct": "",
        "time zone": "Zona horaria",
        "total": "Total",
        "tutorials": "Tutoriales",
        "TxAdasFirmware": "Carga del firmware ADAS",
        "TxAgpsMt3333": "Transferencia de archivos AGPSM",
        "TxAgpsQuectelL89": "Transferencia de archivos AGPSQ",
        "TxAutoscanCanConfiguration": "Cargar archivo OEM de escaneo automático",
        "TxBleFirmware": "Carga de firmware BLE",
        "TxBlueNrgFirmware": "Cargar el firmware BlueNrg",
        "TxBluetoothAuthorizationList": "Cargar lista de autorizaciones Bluetooth",
        "TxBundleBle": "Carga de firmware BLE",
        "TxBundleBleDtb": "Carga BLE DTB",
        "TxBundleCan": "Cargar firmware CAN",
        "TxBundleCanDtb": "Carga CAN DTB",
        "TxBundleDtb": "Cargar DTB principal",
        "TxBundleFirmware": "Cargar firmware principal",
        "TxCanAdapterModeChange": "Cambiar el modo del adaptador CAN externo",
        "TxCanAdapterModeChangeInternal": "Cambiar el modo del adaptador CAN interno",
        "TxCanAdapterUpdate": "Carga del firmware del adaptador CAN",
        "TxCanAdapterUpdateInternal": "Actualización del adaptador CAN interno",
        "TxCanChipFirmware": "Cargar el firmware del chip CAN FMXY50",
        "TxCanConfiguration": "Cargar archivo OEM",
        "TxCarrierAdvanceFirmware": "Actualización del firmware Carrier Advance",
        "TxCarrierAdvanceSettings": "Actualizar la configuración Carrier Advance",
        "TxCarrierApxFirmware": "Actualización del firmware Carrier APX",
        "TxCarrierApxSettings": "Actualizar la configuración de Carrier APX",
        "TxConfiguration": "Configuración de la carga",
        "TxDsmFirmware": "Cargar firmware DSM",
        "TxDtb": "Cargar DTB",
        "TxFirmware": "Carga de firmware",
        "TxFirmwareBundle": "Cargar contenedor de paquetes de firmware",
        "TxFirmwareBundleParts": "Cargar paquete de firmware",
        "TxFotaCertificate": "Actualizar certificado FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Asistente de descarga de GNSS-M",
        "TxGNSSMFirmware": "Carga del firmware GNSS-M",
        "TxManualGeofenceList": "Cargar lista de escenarios de geovallas manuales",
        "TxMeigModemDeltaFirmware": "Cargar el firmware del módem MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Cargar el firmware del módem NETPRISMA Delta",
        "TxObdChipFirmware": "Actualización del chip OBD",
        "TxObdConfig": "Transferencia del archivo de configuración OBD",
        "TxOneWireAuthorizationList": "Cargar lista de autorizaciones 1-Wire",
        "TxPSub": "Transferir archivo de suscripción",
        "TxQuectelModemDeltaFirmware": "Cargar el firmware del módem Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Cargar certificado TLS de usuario",
        "users": "Usuarios",
        "Unknown": "Desconocido",
        "unknown": "Desconocido",
        "unknown model_platform": "Plataforma desconocida",
        "unknown origin": "",
        "unknown platform": "Plataforma desconocida",
        "unrestricted": "Sin restricciones",
        "Verifying": "Verificación",
        "vin": "VIN",
        "vip status": "Estado VIP",
        "wd_log": "Registro WD",
        "yes": "Sí"
    },
    "Maintenance": {
        "title": "¡Un momento! Estamos realizando tareas de mantenimiento."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} falló debido a un error del servidor.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para cancelar todas las tareas seleccionadas. Algunas tareas están asociadas a recursos de diferentes empresas.",
            "Cancel tasks action failed. No resources found.": "No hay tareas que coincidan con su selección. Revise su selección de tareas e inténtelo de nuevo.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "La empresa «{{SourceCompanyName}}» ({{SourceCompanyId}}) se fusionó con «{{TargetCompanyName}}» ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "La fusión de empresas ha fallado. Las empresas «{{SourceCompanyId}}» y «{{TargetCompanyId}}» no se pueden fusionar debido a configuraciones o permisos incompatibles.",
            "Create device group tasks action failed. No resources found.": "No se han podido crear tareas para Smart Group. Intente reasignar el archivo.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} tareas creadas para el grupo de dispositivos con ID:{{GroupId}} dispositivos.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "No tienes permiso para crear tareas para todos los dispositivos seleccionados. Algunos dispositivos pertenecen a diferentes empresas.",
            "Create tasks action failed. No resources found.": "No hay dispositivos que coincidan con su selección. Revise su selección de dispositivos e inténtelo de nuevo.",
            "Create tasks action failed. No resources processed.": "No se han podido procesar los dispositivos seleccionados. Intente crear el grupo de tareas de nuevo.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para eliminar todas las empresas seleccionadas. Algunas empresas no están bajo su gestión directa.",
            "Delete companies action failed. No resources found.": "No hay empresas que coincidan con su selección. Revise su selección de empresas e inténtelo de nuevo.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para eliminar todos los archivos seleccionados. Algunos archivos están asociados a recursos de diferentes empresas.",
            "Delete files action failed. No resources found.": "No hay archivos que coincidan con su selección. Revise su selección de archivos e inténtelo de nuevo.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para eliminar todos los grupos de dispositivos seleccionados. Algunos grupos de dispositivos contienen recursos de diferentes empresas.",
            "Delete groups action failed. No resources found.": "No hay grupos de dispositivos que coincidan con su selección. Revise la selección de grupos de dispositivos e inténtelo de nuevo.",
            "Delete product codes action failed. No resources found.": "No hay códigos de producto que coincidan con su selección. Revise su selección de códigos de producto y vuelva a intentarlo.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para eliminar todos los usuarios seleccionados. Algunos usuarios pertenecen a diferentes empresas.",
            "Delete users action failed. No resources found.": "No hay usuarios que coincidan con su selección. Revise su selección de usuarios e inténtelo de nuevo.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} dispositivo(s) exportado(s) a «{{Filename}}».",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} dispositivos importados.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} dispositivos procesados, {{TasksCreatedCount}} tareas creadas.",
            "Export devices action failed. No resources found.": "No hay dispositivos que coincidan con su selección. Revise su selección de dispositivos e inténtelo de nuevo.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} tareas devueltas a pendiente en el grupo de tareas {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Ámbito de solicitud no válido. Los recursos deben pertenecer a una única raíz.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} empresas eliminadas.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} grupos de dispositivos eliminados.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} atributos de dispositivos actualizados.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} modelos de dispositivos eliminados.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} dispositivos actualizados.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} archivo(s) eliminado(s).",
            "{{ProcessedCount}} product code(s) deleted.": "Se han eliminado {{ProcessedCount}} códigos de producto.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} tareas canceladas.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} tareas actualizadas.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} usuario(s) eliminado(s).",
            "Retry tasks action failed. No resources found.": "No hay tareas que coincidan con su selección. Revise su selección de tareas e inténtelo de nuevo.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para transferir todos los dispositivos seleccionados. Algunos dispositivos pertenecen a diferentes empresas.",
            "Transfer devices action failed. No resources found.": "No hay dispositivos que coincidan con su selección. Revise su selección de dispositivos e inténtelo de nuevo.",
            "Transfer devices action failed. No resources processed.": "No se han podido procesar los dispositivos seleccionados. Intente transferir los dispositivos de nuevo.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} de {{TotalDevicesToTransfer}} dispositivos transferidos.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "No tienes permiso para actualizar todos los dispositivos seleccionados. Algunos dispositivos pertenecen a diferentes empresas.",
            "Update devices action failed. No resources found.": "No hay dispositivos que coincidan con su selección. Revise su selección de dispositivos e inténtelo de nuevo.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "No tiene permiso para actualizar los atributos de todos los dispositivos seleccionados. Algunos dispositivos pertenecen a diferentes empresas.",
            "Update devices attributes action failed. No resources found.": "No hay dispositivos que coincidan con su selección. Revise su selección de dispositivos e inténtelo de nuevo.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "No tienes permiso para actualizar todas las tareas seleccionadas. Algunas tareas están asociadas a recursos de diferentes empresas.",
            "Update tasks action failed. No resources found.": "No hay tareas que coincidan con su selección. Revise su selección de tareas e inténtelo de nuevo.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Sin notificaciones",
        "notifications": "Notificaciones",
        "notifications will be listed": "Todas las notificaciones nuevas se mostrarán aquí",
        "remove notification": "Eliminar notificación",
        "see previous notifications": "Ver notificaciones anteriores",
        "timestamps": {
            "days ago": "Hace {{days}} días",
            "hours ago": "Hace {{hours}} horas",
            "minutes ago": "Hace {{minutes}} minutos",
            "moments ago": "Hace unos instantes"
        },
        "title": {
            "BackgroundActionFailed": "Acción fallida",
            "CompaniesSuccessfullyDeleted": "Empresas eliminadas con éxito",
            "CompanyBulkDeleteFailed": "Se ha producido un error al eliminar empresas",
            "CompanyLevelChanged": "Cambio a nivel de empresa",
            "CompanyLevelDowngradeReminder": "Próxima rebaja de categoría a nivel de empresa",
            "CompanyMergeFailed": "Se ha producido un error al fusionar empresas",
            "CompanySuccessfullyMerged": "Empresas fusionadas con éxito",
            "DeviceAttributesSuccessfullyUpdated": "Atributos del dispositivo actualizados correctamente",
            "DeviceBulkAttributeUpdateFailed": "Se ha producido un error al actualizar los atributos del dispositivo",
            "DeviceBulkUpdateFailed": "Se ha producido un error al actualizar los dispositivos",
            "DeviceExportFailed": "Se ha producido un error al exportar dispositivos",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Grupos de dispositivos eliminados correctamente",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Se ha producido un error al crear tareas de Smart Group",
            "DeviceGroupTasksSuccessfullyCreated": "Tareas de grupo inteligente creadas correctamente",
            "DeviceModelBulkDeleteFailed": "Se ha producido un error al eliminar modelos de dispositivos",
            "DeviceModelsSuccessfullyDeleted": "Modelos de dispositivos eliminados correctamente",
            "DevicesSuccessfullyTransferred": "Dispositivos transferidos correctamente",
            "DevicesSuccessfullyUpdated": "Dispositivos actualizados correctamente",
            "DeviceTransferFailed": "Se ha producido un error durante la transferencia de dispositivos",
            "ExportFailed": "Error al exportar recursos",
            "ExportSucceeded": "Dispositivos exportados correctamente",
            "FailedTasksRetryFailed": "Se ha producido un error al reintentar las tareas",
            "FailedTasksSuccessfullyRetried": "Tareas reintentadas con éxito",
            "FileBulkDeleteFailed": "Se ha producido un error al eliminar archivos",
            "FilesSuccessfullyDeleted": "Archivos eliminados correctamente",
            "GroupBulkDeleteFailed": "Se ha producido un error al eliminar grupos de dispositivos",
            "ImportFailed": "Error al importar recursos",
            "ImportSucceeded": "Dispositivos importados correctamente",
            "ProductCodeBulkDeleteFailed": "Se ha producido un error al eliminar los códigos de producto",
            "ProductCodesSuccessfullyDeleted": "Códigos de producto eliminados correctamente",
            "ResourceUpdateFailed": "Error al actualizar los recursos",
            "ResourceUpdateSucceeded": "Actualización de recursos realizada correctamente",
            "RoleBulkDeleteFailed": "Se ha producido un error al eliminar roles",
            "RolesSuccessfullyDeleted": "Roles eliminados correctamente",
            "TaskBulkCancelFailed": "Se ha producido un error al cancelar las tareas",
            "TaskBulkCreateFailed": "Se ha producido un error al crear un grupo de tareas",
            "TaskBulkUpdateFailed": "Se ha producido un error al actualizar las tareas",
            "TaskGroupSuccessfullyCreated": "Grupo de tareas creado correctamente",
            "TasksPropagationFailed": "Error en la propagación de tareas",
            "TasksPropagationSucceeded": "La propagación de tareas se ha realizado correctamente",
            "TasksPropagationWarning": "La tarea de propagación de tareas ha finalizado con advertencias",
            "TasksSuccessfullyCanceled": "Tareas canceladas correctamente",
            "TasksSuccessfullyUpdated": "Tareas actualizadas correctamente",
            "UserBulkDeleteFailed": "Se ha producido un error al eliminar usuarios",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Usuarios eliminados correctamente."
        }
    },
    "Permission actions": {
        "Access": "Integración TCT",
        "Create": "Crear",
        "Delete": "Eliminar",
        "Download": "Descargar",
        "Export": "Exportar",
        "Merge": "Fusionar",
        "Read": "Leer",
        "Retry": "Reintentar",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Transferencia",
        "Unlock": "Desbloquear",
        "Update": "Actualizar"
    },
    "Permission groups": {
        "company": "Empresas",
        "device": "Dispositivos",
        "device group": "Grupos de dispositivos",
        "file": "Archivos",
        "role": "Funciones",
        "task": "Tareas",
        "task group": "Grupos de tareas",
        "token": "Tokens",
        "user": "Usuarios"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Esta opción está desactivada para los usuarios con nivel básico de empresa.",
                "token list": "Los tokens de integración de API están desactivados para los usuarios con nivel básico de empresa."
            },
            "custom_role_support": {
                "create role": "Esta función solo pueden utilizarla los usuarios con nivel Premium de empresa.",
                "edit role": "Esta función solo pueden utilizarla los usuarios con nivel Premium de empresa. Las funciones personalizadas creadas anteriormente se pueden eliminar.",
                "edit user": "Esta función solo pueden utilizarla los usuarios con nivel Premium de empresa. Se pueden eliminar los roles personalizados asignados anteriormente."
            },
            "task_schedule_support": {
                "table head": "Esta función solo pueden utilizarla los usuarios con niveles de empresa Estándar y Premium. Las tareas añadidas anteriormente con programaciones se seguirán ejecutando."
            }
        },
        "general message": "Esta función solo pueden utilizarla los usuarios con niveles de empresa Estándar y Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "No se pueden crear tareas para más de {{limitCount}} dispositivos a la vez."
        }
    },
    "Search": {
        "code": "Código",
        "description": "Descripción",
        "email": "Correo electrónico",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modelo",
        "name": "Nombre",
        "product code": "Código del producto",
        "role name": "Nombre del rol",
        "serial": "N.º de serie",
        "search by": "Buscar por",
        "search company name": "Buscar nombre de empresa"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Está a punto de desactivar la autenticación de dos factores. Esto podría hacer que su cuenta FOTA WEB sea insegura. ¿Está seguro de que desea continuar?",
                    "title": "¿Estás seguro?"
                },
                "send email code": {
                    "enter code": "Por motivos de seguridad, introduzca el código para verificar el correo electrónico."
                },
                "send otp code": {
                    "description": "Se ha enviado un código de 6 dígitos a su aplicación de autenticación. Por motivos de seguridad, introduzca el código generado en el campo siguiente.",
                    "no access": {
                        "authenticator": "Si ya no tiene acceso a la aplicación de autenticación vinculada a esta cuenta, es necesario cambiar la contraseña para desactivar la autenticación de dos factores.",
                        "email": "Si ya no tiene acceso al correo electrónico vinculado a esta cuenta, es necesario cambiar la contraseña para desactivar la autenticación multifactorial."
                    }
                },
                "title": "Desactivar la autenticación de dos factores."
            },
            "get email code": {
                "description": "Utiliza ese código en la siguiente pantalla para verificar tu cuenta.",
                "description modal": "Utiliza ese código para verificar tu cuenta.",
                "title": "Al pulsar «Enviar código», se enviará un código único a <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Necesitará una aplicación móvil de autenticación para completar este proceso, como una de las siguientes:"
            },
            "select authentication type": {
                "authentication app description": "Obtenga un código único de una aplicación como Microsoft Authenticator o Google Authenticator.",
                "description": "Para mantener la seguridad de su cuenta y los datos de sus clientes, utilice una de las siguientes opciones para configurar la autenticación de dos factores.",
                "description modal": "Seleccione su método de autenticación preferido.",
                "email": "Correo electrónico",
                "email description": "Le enviaremos un código único a su correo electrónico cada vez que intente iniciar sesión.",
                "recommended": "Recomendado",
                "title": "La autenticación de dos factores (2FA) es obligatoria para todos los usuarios de FOTA WEB.",
                "title modal": "Seleccionar método de autenticación"
            },
            "send email code": {
                "description": "Introduzca el código en el campo siguiente y pulse «Verificar» para continuar.",
                "enter code": "Introduzca el código para verificar el correo electrónico.",
                "title": "Se ha enviado un código único a <1>{{email}}</1>.",
                "verification code": "Código de verificación"
            },
            "send otp code": {
                "click to scan code": "Haga clic aquí para escanear un código QR",
                "click to type code": "Haga clic aquí para escribir el código manualmente",
                "incorrect code": "Código incorrecto",
                "scan QR code": "Escanea el código QR en tu aplicación",
                "six digit code": "Código de 6 dígitos generado por su aplicación",
                "title": "Necesitará una aplicación móvil de autenticación para completar este proceso, como: <1>Microsoft Authenticator</1> o <2>Google Authenticator</2>.",
                "type text code": "Introduzca el código de texto en su aplicación"
            },
            "settings": {
                "description": "La autenticación de dos factores es una capa adicional de seguridad que verifica su identidad con algo que usted sabe (contraseña) y algo que usted tiene (teléfono, llave de seguridad, correo electrónico).",
                "disabled": "Desactivado",
                "enabled": "Habilitado",
                "title": "Autenticación de dos factores."
            },
            "success message": {
                "alert": "Autenticación de dos factores habilitada con éxito.",
                "description": "Le pediremos un código de autenticación cada vez que inicie sesión con su correo electrónico y contraseña.",
                "title": "Ha habilitado correctamente la autenticación de dos factores.",
                "title modal": "¡Autenticación de dos factores habilitada!"
            },
            "title": {
                "authentication app": "Aplicación de autenticación",
                "authentication email": "Correo electrónico de autenticación",
                "is enabled": "Autenticación de dos factores habilitada.",
                "protect your account": "Proteja su cuenta FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Cambiar contraseña",
            "enter current password": "Introduzca la contraseña actua",
            "enter new password": "Introduzca una nueva contraseña",
            "hide password": "Ocultar contraseña",
            "repeat new password": "Repita la nueva contraseña",
            "rules": {
                "lowercase letter": "Al menos una letra minúscula (a-z)",
                "minimum characters": "Al menos 12 caracteres",
                "new and current passwords must not match": "Las contraseñas nuevas y actuales no deben coincidir",
                "new passwords must match": "Las nuevas contraseñas deben coincidir",
                "number": "Al menos un número",
                "passwords must match": "Las contraseñas deben coincidir",
                "special symbol": "Al menos un símbolo especial (!@#$%^&*()-_=+)",
                "uppercase letter": "Al menos una letra mayúscula (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Mostrar contraseña"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Estadísticas de la tabla",
        "statistics message": "Los filtros de la tabla afectarán a las estadísticas que se muestran a continuación",
        "activity": "Actividad",
        "model": "Modelo",
        "firmware": "Firmware",
        "configuration": "Configuración",
        "statistics": "Estadísticas"
    },
    "Table": {
        "1_wire_authorization": "Autorización de 1 cable",
        "access group": "",
        "access groups": "",
        "access level": "Nivel de acceso",
        "accessories": "Accesorios",
        "action": "Acción",
        "action date": "Fecha de acción",
        "assigned package": "Paquete asignado",
        "attempt count": "Recuento de intentos",
        "attribute": "Atributo",
        "attributes": "Atributos",
        "auto sync": "",
        "batch id": "ID de lote",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "Autorización Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adaptador CAN",
        "can adapter name": "Nombre del adaptador CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Paquete de archivos OEM",
        "can oem file vehicle": "Vehículo de archivos OEM",
        "can package": "Paquete CAN",
        "can program number": "Número de programa CAN",
        "can software date": "Fecha del software CAN",
        "can type": "Tipo CAN",
        "carrier module id": "ID del módulo",
        "carrier revision": "Revisión",
        "carrier serial id": "ID de serie",
        "carrier settings filename": "Nombre del archivo de configuración",
        "carrier unit status": "Estado",
        "carrier unit type": "Tipo de unidad",
        "changed at": "Modificado en",
        "change origin": "",
        "changes": "Cambios",
        "checkbox disabled": {
            "role": "Las funciones estáticas no se pueden editar ni eliminar."
        },
        "child company": "<0>Filial de</0><1>{{parentCompany}}</1>",
        "child companies": "Empresas filiales",
        "code": "Código",
        "company": "Empresa",
        "company hierarchy": "Jerarquía de la empresa",
        "company name": "Nombre de la empresa",
        "compatibility": "Compatibilidad",
        "configuration": "Configuración",
        "configuration details": "Detalles de configuración",
        "configuration type": "",
        "created at": "Creado en",
        "created by": "Creado por",
        "date": "Fecha",
        "description": "Descripción",
        "device details": "Detalles del dispositivo",
        "device company": "Empresa de dispositivos",
        "device description": "Descripción del dispositivo",
        "device group": "Grupo de dispositivos",
        "device imei": "IMEI del dispositivo",
        "device model": "Modelo de dispositivo",
        "device seen at": "Dispositivo visto en",
        "device serial": "Número de serie del dispositivo",
        "devices": "Dispositivos",
        "devices count": "Recuento de dispositivos",
        "Done": "Hecho",
        "download at": "",
        "download file": "Descargar archivo",
        "dtb": "DTB",
        "edit file": "Editar archivo",
        "email": "Correo electrónico",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Tan pronto como se creen los grupos de tareas, podrás ver la lista aquí",
                    "changes": "Tan pronto como se realicen cambios, podrá ver la lista aquí",
                    "companies": "Tan pronto como se creen las empresas, podrás ver la lista aquí",
                    "configurationChanges": "",
                    "desktopLicenses": "Tan pronto como se creen las licencias desktop, podrá ver la lista aquí",
                    "devices": "Tan pronto como los dispositivos se carguen en FOTA WEB, podrá ver la lista aquí",
                    "files": "Tan pronto como se carguen los archivos, podrá ver la lista aquí",
                    "groups": "Tan pronto como se creen los grupos, podrás ver la lista aquí",
                    "offlineLicenses": "Tan pronto como se creen las licencias sin conexión, podrá ver la lista aquí",
                    "permissions": "Tan pronto como se asignen los permisos al usuario, podrá ver la lista aquí",
                    "productCodes": "Tan pronto como se creen los códigos de producto, podrá ver la lista aquí",
                    "roles": "Tan pronto como se creen los roles, podrás ver la lista aquí",
                    "tasks": "Tan pronto como se creen las tareas, podrás ver la lista aquí",
                    "users": "Tan pronto como se añadan usuarios, podrá ver la lista aquí"
                },
                "title": {
                    "batches": "La tabla de grupos de tareas está vacía",
                    "changes": "La tabla de cambios está vacía",
                    "companies": "La tabla de empresas está vacía",
                    "configurationChanges": "",
                    "desktopLicenses": "La tabla de licencias de desktop está vacía",
                    "devices": "La tabla de dispositivos está vacía",
                    "files": "La tabla de archivos está vacía",
                    "groups": "La tabla de grupos está vacía",
                    "offlineLicenses": "La tabla de licencias sin conexión está vacía",
                    "permissions": "La tabla de permisos está vacía",
                    "productCodes": "La tabla de códigos de productos está vacía",
                    "roles": "La tabla de roles está vacía",
                    "tasks": "La tabla de tareas está vacía",
                    "users": "La tabla de usuarios está vacía"
                }
            },
            "no permission": {
                "description": "Póngase en contacto con su administrador para solicitar acceso.",
                "title": "No tienes los permisos necesarios para ver este contenido"
            },
            "no results found": {
                "description": "Prueba con otra palabra clave o filtro para obtener resultados",
                "title": "No se han encontrado resultados"
            },
            "button": {
                "add": {
                    "companies": "Crear empresa",
                    "devices": "Añadir dispositivo",
                    "files": "Subir archivo",
                    "groups": "Crear grupo",
                    "productCodes": "Añadir código de producto",
                    "tasks": "Crear tarea",
                    "users": "Invitar a usuarios"
                },
                "reset view": "Restablecer vista"
            }
        },
        "exausted autoscan limit": "Límite de escaneo automático agotado hasta",
        "exausted vin parsing limit": "Límite de análisis de VIN agotado hasta",
        "expiration": "Caducidad",
        "expiration date": "Fecha de caducidad",
        "expires at": "Caduca en",
        "expiry date": "Fecha de caducidad",
        "field": "Campo",
        "file": "Archivo",
        "file id": "ID de archivo",
        "files": "Archivos",
        "file type": "Tipo de archivo",
        "filter by": "Filtrar por",
        "firmware": "Firmware",
        "general": "General",
        "general data": "Datos generales",
        "gnss version": "Versión GNSS",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "group vip status": "",
        "gsm number": "Número GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "Plataforma FMx: modelos FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) y TMT.",
                "ft platform": "<1>Plataforma FT</1>: modelos FTx y ATx.",
                "legacy platform": "<1>Plataforma heredada</1>: modelos FM (excepto FM4001 y FM3010), FMA y GH (GH4000).",
                "title": "Generación de la plataforma del dispositivo telemático"
            },
            "visibility": "<2>Los cambios etiquetados como <1>Internos</1> no son visibles para los clientes.</2><2>Dado que los cambios en los dispositivos pueden incluir datos visibles y ocultos, <1>no comparta capturas de pantalla ni detalles en comunicaciones externas</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Información",
        "interface": "Interfaz",
        "invited by": "Invitado por",
        "items": "elementos",
        "last checked at": "Última comprobación en",
        "last sign in": "Último inicio de sesión",
        "last status update": "Última actualización de estado",
        "last used at": "Último uso en",
        "license disabled": "Desactivado",
        "license enabled": "Habilitado",
        "license key": "Clave de licencia",
        "license name": "",
        "links": "Enlaces",
        "manual_geofence_scenarios": "Escenarios de geovallas manuales",
        "message": "Mensaje",
        "model": "Modelo",
        "model task type support": {
            "false": "No compatible",
            "true": "Compatible"
        },
        "modem version": "Versión módem",
        "name": "Nombre",
        "new value": "Nuevo valor",
        "next task": "Siguiente tarea",
        "no changes": "Sin cambios",
        "no company name": "Sin nombre de empresa",
        "no details": "Sin detalles",
        "no file": "Sin archivos",
        "no imei available": "No hay IMEI disponible",
        "no model": "Sin modelo",
        "no parent company": "La empresa no tiene una empresa matriz.",
        "no tasks": "El dispositivo no tiene tareas.",
        "number": "Número",
        "obd": "OBD",
        "obd chip firmware version": "Versión del firmware del chip OBD",
        "of": "de",
        "offline licenses tab disabled": "Las licencias sin conexión no están disponibles para las licencias de desktop desactivadas.",
        "origin": "",
        "original value": "Valor original",
        "other information": "Otra información",
        "page of": "página de",
        "parent company": "Empresa matriz",
        "permission count": "Recuento de permisos",
        "platform": "Plataforma",
        "Price": "Precio",
        "product code": "Código del producto",
        "program number": "Número de programa",
        "property": "Propiedad",
        "queue": "Cola",
        "receiving company": "Empresa receptora",
        "revision": "Revisión",
        "role": "Función",
        "role name": "Nombre del rol",
        "rows per page": "Filas por página",
        "running": "En funcionamiento",
        "schedule": "Programar",
        "seen at": "Visto en",
        "select row": "Seleccione una fila para ver los detalles",
        "send sms": "Envío de SMS",
        "serial": "N.º de serie.",
        "show details": {
            "desktopLicenses": "Mostrar detalles de la licencia de desktop",
            "devices": "Mostrar detalles del dispositivo",
            "batches": "Mostrar detalles del grupo de tareas",
            "tasks": "Mostrar detalles de la tarea",
            "companies": "Mostrar detalles de la empresa"
        },
        "sim": "SIM",
        "size": "Tamaño",
        "software date": "Fecha del software",
        "source company": "Empresa de origen",
        "spec_id": "Spec ID",
        "status": "Estado",
        "status id": "ID de estado",
        "status name": "Nombre del estado",
        "supported task types": "Tipos de tareas compatibles",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Columnas de la tabla",
        "target company": "Empresa objetivo",
        "task id": "ID de tarea",
        "task queue": "Cola de tareas",
        "tasks": "Tareas",
        "task type": "Tipo de tarea",
        "tct web support": "Soporte web de TCT web",
        "total": "Total",
        "type": "Tipo",
        "updated at": "Actualizado el",
        "updated by": "Actualizado por",
        "unknown": "Desconocido",
        "user cannot be deleted": "No se pueden eliminar usuarios.",
        "user cannot be edited": "El usuario no puede ser editado.",
        "user cannot delete himself": "Los usuarios no pueden eliminar su propio perfil.",
        "user date statuses": {
            "expired": "Caducado",
            "expires": "Caduca",
            "never expires": "No caduca nunca",
            "sent": "Enviado"
        },
        "user email": "Correo electrónico del usuario",
        "user invitation cannot be cancelled": "Las invitaciones a usuarios no se pueden cancelar.",
        "user invitation cannot be resent": "No se pueden reenviar invitaciones a usuarios.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Activo",
            "Inactive": "Inactivo",
            "InvitationExpired": "Invitación caducada",
            "InvitationPending": "Invitación pendiente"
        },
        "users": "Usuarios",
        "value from": "Valor desde",
        "value to": "Valor hasta",
        "view all roles": "Ver todo ({{count}})",
        "vin": "VIN",
        "vip status": "Estado VIP",
        "visibility": "Visibilidad"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Información sobre permisos",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Nombre de la interfaz del accesorio.",
                    "type": "Tipo de accesorio conectado."
                },
                "can": {
                    "assigned package": "El paquete OEM asignado al dispositivo.",
                    "can oem file package": "El paquete OEM notificado durante la última conexión.",
                    "can oem file vehicle": "La configuración del vehículo OEM comunicada durante la última conexión.",
                    "dtb": "",
                    "firmware": "La versión del firmware CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "La última cadena de inicio del adaptador CAN recibida que contiene los datos actuales y el número de programa del adaptador.",
                    "program number": "El número de programa del adaptador CAN.",
                    "revision": "",
                    "software date": "La fecha del software del adaptador CAN.",
                    "type": "El tipo de adaptador CAN."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "El último nombre de archivo de la lista de autorizaciones 1-Wire enviado.",
                    "bluetooth_authorization": "El último nombre de archivo de la lista de autorizaciones Bluetooth enviado.",
                    "main configuration": "El último nombre del archivo de configuración principal enviado.",
                    "manual_geofence_scenarios": "El último nombre de archivo de la lista de geovallas manuales enviado."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "La versión del firmware BLE notificada durante la última conexión.",
                    "bluetooth password": "",
                    "bootloader": "La versión del gestor de arranque del dispositivo comunicada durante la última conexión.",
                    "company": "La empresa propietaria de este dispositivo.",
                    "configuration": "El nombre del último archivo de configuración enviado por el configurator.",
                    "description": "Descripción del dispositivo (definida por el usuario).",
                    "dtb": "La versión del blob del árbol de dispositivos notificada durante la última conexión.",
                    "firmware": "La versión del firmware del dispositivo comunicada durante la última conexión.",
                    "gnss version": "La versión de GNSS comunicada durante la última conexión.",
                    "group": "El grupo de dispositivos al que está asignado este dispositivo.",
                    "product code": "El código de producto del dispositivo.",
                    "serial": "El número de serie del dispositivo."
                },
                "obd": {
                    "obd chip firmware version": "La versión del firmware del chip OBD comunicada durante la última conexión.",
                    "vin": "Código único de 17 caracteres que identifica un vehículo de motor específico."
                },
                "sim": {
                    "gsm number": "El número de teléfono público asociado a un dispositivo.",
                    "iccid": "Un número de serie único que identifica una tarjeta SIM.",
                    "imsi": "Identificador único para un suscriptor de red móvil."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "La fecha y hora de creación del usuario.",
                    "id": "El ID único del usuario.",
                    "invited by": "Dirección de correo electrónico del usuario que creó la invitación.",
                    "role": "Funciones asignadas al usuario.",
                    "updated at": "La fecha y hora de la última actualización del usuario."
                }
            }
        },
        "user details": "Detalles del usuario"
    },
    "Task groups": {
        "all": "Todo",
        "bulk type": {
            "CompanyBulkDelete": "Eliminar empresa",
            "DeviceBulkCreate": "Añadir dispositivo",
            "DeviceBulkDelete": "Eliminar dispositivo",
            "DeviceBulkUpdate": "Actualizar dispositivo",
            "FileBulkDelete": "Eliminar archivo",
            "GroupBulkDelete": "Eliminar grupo",
            "TaskBulkCreate": "Crear tarea",
            "TaskBulkUpdate": "Cancelar tarea",
            "UserBulkDelete": "Eliminar usuario"
        },
        "pending approval": "Pendiente de aprobación",
        "already approved": "Ya aprobado",
        "no approval required": "No se requiere aprobación",
        "total objects": "Total de objetos",
        "total tasks": "Tareas totales"
    },
    "Task status": {
        "0": "Pendiente",
        "1": "En funcionamiento",
        "2": "Completado",
        "3": "Completado con errores",
        "4": "Cancelado",
        "5": "Fallido",
        "6": "Caducado",
        "7": "A la espera de aprobación",
        "8": "Verificación",
        "task count": {
            "0": "Tareas pendientes",
            "1": "Tareas en ejecución",
            "3": "Tareas completadas con errores",
            "5": "Tareas fallidas"
        },
        "verified tooltip title": "La tarea se completó con éxito y fue verificada por el dispositivo."
    },
    "Tasks": {
        "0": "La tarea está en la cola y ahora está pendiente.",
        "1": "La tarea se está ejecutando actualmente.",
        "2": "La tarea se completó con éxito.",
        "3": "La tarea se completó, pero se produjeron algunos errores.",
        "4": "La tarea se ha cancelado.",
        "5": "La tarea ha fallado.",
        "6": "La tarea no se completó en un plazo determinado."
    },
    "Tct": {
        "edit configuration": "Editar configuración",
        "no editable configurations": "No se cargan configuraciones editables",
        "open tct": "Versión web abierta de TCT web",
        "open tct description": "Elija entre crear una nueva configuración en la versión web de TCT web o editar un archivo de configuración existente desde FOTA WEB.",
        "select configuration file": "Seleccione el archivo de configuración que desea editar en TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "La versión TCT web solo está disponible para el nivel Premium de empresa."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
